(window.webpackJsonp=window.webpackJsonp||[]).push([[15],{
/***/"+qjT":
/***/function(t,e,i){"use strict";
/* unused harmony export TabElement */
/* harmony import */var r=i("F3iu"),a=i("8u2h"),o=i("CB5s"),n=i("OVu0"),s=i("o5Wi");
/* harmony import */
/**
@license
Copyright (c) 2017 Vaadin Ltd.
This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
*/
/**
 * `<vaadin-tab>` is a Web Component providing an accessible and customizable tab.
 *
 * ```
 *   <vaadin-tab>
 *     Tab 1
 *   </vaadin-tab>
 * ```
 *
 * The following state attributes are available for styling:
 *
 * Attribute  | Description | Part name
 * -----------|-------------|------------
 * `disabled` | Set to a disabled tab | :host
 * `focused` | Set when the element is focused | :host
 * `focus-ring` | Set when the element is keyboard focused | :host
 * `selected` | Set when the tab is selected | :host
 * `active` | Set when mousedown or enter/spacebar pressed | :host
 * `orientation` | Set to `horizontal` or `vertical` depending on the direction of items  | :host
 *
 * See [ThemableMixin – how to apply styles for shadow parts](https://github.com/vaadin/vaadin-themable-mixin/wiki)
 *
 * @extends PolymerElement
 * @mixes ElementMixin
 * @mixes ThemableMixin
 * @mixes ItemMixin
 */
class l extends(Object(n.a)(Object(a.a)(Object(o.a)(r.a)))){static get template(){return s.a`<slot></slot>`}static get is(){return"vaadin-tab"}static get version(){return"3.2.0"}ready(){super.ready(),this.setAttribute("role","tab")}
/**
   * @param {!KeyboardEvent} event
   * @protected
   */_onKeyup(t){const e=this.hasAttribute("active");if(super._onKeyup(t),e){const t=this.querySelector("a");t&&t.click()}}}customElements.define(l.is,l)},
/***/"1UqG":
/***/function(t,e,i){"use strict";
// UNUSED EXPORTS: PasswordFieldElement
// EXTERNAL MODULE: ./node_modules/@vaadin/vaadin-lumo-styles/font-icons.js?babel-target=es6
i("XZNo"),i("70OO");
// EXTERNAL MODULE: ./node_modules/@vaadin/vaadin-lumo-styles/sizing.js?babel-target=es6
var r=i("o5Wi");
// CONCATENATED MODULE: ./node_modules/@vaadin/vaadin-text-field/theme/lumo/vaadin-password-field-styles.js?babel-target=es6
const a=r.a`<dom-module id="lumo-password-field" theme-for="vaadin-password-field"><template><style>[part=reveal-button]::before{content:var(--lumo-icons-eye)}:host([password-visible]) [part=reveal-button]::before{content:var(--lumo-icons-eye-disabled)}[part=reveal-button]{display:var(--lumo-password-field-reveal-button-display,block)}[part=input-field] ::slotted(input)::-ms-reveal{display:none}</style></template></dom-module>`;document.head.appendChild(a.content);
// EXTERNAL MODULE: ./node_modules/@vaadin/vaadin-text-field/theme/lumo/vaadin-text-field.js?babel-target=es6 + 1 modules
i("CThD"),i("F3iu"),i("GgZ1");
// EXTERNAL MODULE: ./node_modules/@polymer/polymer/polymer-element.js?babel-target=es6
var o=i("7vYi"),n=i("O5q1");
// CONCATENATED MODULE: ./node_modules/@vaadin/vaadin-text-field/src/vaadin-password-field.js?babel-target=es6
/**
@license
Copyright (c) 2017 Vaadin Ltd.
This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
*/
const s=r.a`<custom-style><style>@font-face{font-family:vaadin-password-field-icons;src:url(data:application/font-woff;charset=utf-8;base64,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) format('woff');font-weight:400;font-style:normal}</style></custom-style><dom-module id="vaadin-password-field-template"><template><style>::-ms-reveal{display:none}[part=reveal-button][hidden]{display:none!important}</style><div part="reveal-button" on-mousedown="_revealButtonMouseDown" on-touchend="_togglePasswordVisibilityTouchend" on-click="_togglePasswordVisibility" hidden\$="[[revealButtonHidden]]"></div></template></dom-module>`;let l;
/**
 * `<vaadin-password-field>` is a Web Component for password field control in forms.
 *
 * ```html
 * <vaadin-password-field label="Password">
 * </vaadin-password-field>
 * ```
 *
 * ### Styling
 *
 * See vaadin-text-field.html for the styling documentation
 *
 * In addition to vaadin-text-field parts, here's the list of vaadin-password-field specific parts
 *
 * Part name       | Description
 * ----------------|----------------------------------------------------
 * `reveal-button` | The eye icon which toggles the password visibility
 *
 * In addition to vaadin-text-field state attributes, here's the list of vaadin-password-field specific attributes
 *
 * Attribute    | Description | Part name
 * -------------|-------------|------------
 * `password-visible` | Set when the password is visible | :host
 *
 * See [ThemableMixin – how to apply styles for shadow parts](https://github.com/vaadin/vaadin-themable-mixin/wiki)
 *
 * @extends TextFieldElement
 * @demo demo/index.html
 */document.head.appendChild(s.content);class d extends o.a{static get is(){return"vaadin-password-field"}static get version(){return"2.9.1"}static get properties(){return{
/**
       * Set to true to hide the eye icon which toggles the password visibility.
       * @attr {boolean} reveal-button-hidden
       * @type {boolean}
       */
revealButtonHidden:{type:Boolean,value:!1},
/**
       * True if the password is visible ([type=text]).
       * @attr {boolean} password-visible
       * @type {boolean}
       */
passwordVisible:{type:Boolean,value:!1,reflectToAttribute:!0,observer:"_passwordVisibleChange",readOnly:!0}}}static get template(){if(!l){
// Clone the superclass template
l=super.template.cloneNode(!0);// Retrieve this element's dom-module template
const t=n.a.import(this.is+"-template","template"),e=t.content.querySelector('[part="reveal-button"]'),i=t.content.querySelector("style");l.content.querySelector('[part="input-field"]').appendChild(e),l.content.appendChild(i)}return l}
/** @protected */ready(){super.ready(),this.inputElement.type="password",this.inputElement.autocapitalize="off",this.addEventListener("focusout",()=>{this._passwordVisibilityChanging||(this._setPasswordVisible(!1),this._cachedChangeEvent&&this._onChange(this._cachedChangeEvent))})}
/**
   * @param {!Event} e
   * @protected
   */_onChange(t){this.querySelector(`${this._slottedTagName}[slot="${this._slottedTagName}"]`)&&t.stopPropagation(),this._passwordVisibilityChanging?this._cachedChangeEvent=t:(this._cachedChangeEvent=null,super._onChange(t))}
/** @private */_revealButtonMouseDown(t){this.hasAttribute("focused")&&t.preventDefault()}
/** @private */_togglePasswordVisibilityTouchend(t){
// Cancel the following click event
t.preventDefault(),this._togglePasswordVisibility(),this.inputElement.focus()}
/** @private */_togglePasswordVisibility(){this._passwordVisibilityChanging=!0,this.inputElement.blur(),this._setPasswordVisible(!this.passwordVisible),this.inputElement.focus(),this._passwordVisibilityChanging=!1}
/** @private */_passwordVisibleChange(t){this.inputElement.type=t?"text":"password"}}customElements.define(d.is,d)},
/***/"6mkC":
/***/function(t,e,i){"use strict";
// UNUSED EXPORTS: UploadElement
// EXTERNAL MODULE: ./node_modules/@vaadin/vaadin-lumo-styles/font-icons.js?babel-target=es6
i("XZNo"),i("h/KH"),i("70OO"),i("fBRI"),i("y+0W"),i("7L45"),i("zCHs"),i("9slb"),i("AoYb");
// EXTERNAL MODULE: ./node_modules/@vaadin/vaadin-lumo-styles/color.js?babel-target=es6
var r=i("o5Wi");
// CONCATENATED MODULE: ./node_modules/@vaadin/vaadin-upload/theme/lumo/vaadin-upload-styles.js?babel-target=es6
const a=r.a`<dom-module id="lumo-upload" theme-for="vaadin-upload"><template><style>:host{line-height:var(--lumo-line-height-m)}:host(:not([nodrop])){overflow:hidden;border:1px dashed var(--lumo-contrast-20pct);border-radius:var(--lumo-border-radius);padding:var(--lumo-space-m);transition:background-color .6s,border-color .6s}[part=primary-buttons]>*{display:inline-block;white-space:nowrap}[part=drop-label]{display:inline-block;white-space:normal;padding:0 var(--lumo-space-s);color:var(--lumo-secondary-text-color);font-family:var(--lumo-font-family)}:host([dragover-valid]){border-color:var(--lumo-primary-color-50pct);background:var(--lumo-primary-color-10pct);transition:background-color .1s,border-color .1s}:host([dragover-valid]) [part=drop-label]{color:var(--lumo-primary-text-color)}:host([max-files-reached]) [part=drop-label]{color:var(--lumo-disabled-text-color)}[part=drop-label-icon]{display:inline-block}[part=drop-label-icon]::before{content:var(--lumo-icons-upload);font-family:lumo-icons;font-size:var(--lumo-icon-size-m);line-height:1;vertical-align:-.25em}</style></template></dom-module><dom-module id="lumo-upload-file" theme-for="vaadin-upload-file"><template><style include="lumo-field-button">:host{padding:var(--lumo-space-s) 0}:host(:not(:first-child)){border-top:1px solid var(--lumo-contrast-10pct)}[part=row]{display:flex;align-items:baseline;justify-content:space-between}[part=error],[part=status]{color:var(--lumo-secondary-text-color);font-size:var(--lumo-font-size-s)}[part=info]{display:flex;align-items:baseline;flex:auto}[part=meta]{width:.001px;flex:1 1 auto}[part=name]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}[part=commands]{display:flex;align-items:baseline;flex:none}[part=done-icon],[part=warning-icon]{margin-right:var(--lumo-space-xs)}[part=done-icon][hidden]+[part=warning-icon][hidden]{display:block!important;visibility:hidden}[part=done-icon],[part=warning-icon]{font-size:var(--lumo-icon-size-m);font-family:lumo-icons;line-height:1}[part=clear-button],[part=retry-button],[part=start-button]{flex:none;margin-left:var(--lumo-space-xs)}[part=clear-button]::before,[part=done-icon]::before,[part=retry-button]::before,[part=start-button]::before,[part=warning-icon]::before{vertical-align:-.25em}[part=done-icon]::before{content:var(--lumo-icons-checkmark);color:var(--lumo-primary-text-color)}[part=warning-icon]::before{content:var(--lumo-icons-error);color:var(--lumo-error-text-color)}[part=start-button]::before{content:var(--lumo-icons-play)}[part=retry-button]::before{content:var(--lumo-icons-reload)}[part=clear-button]::before{content:var(--lumo-icons-cross)}[part=error]{color:var(--lumo-error-text-color)}[part=progress]{width:auto;margin-left:calc(var(--lumo-icon-size-m) + var(--lumo-space-xs));margin-right:calc(var(--lumo-icon-size-m) + var(--lumo-space-xs))}[part=progress][complete],[part=progress][error]{display:none}</style></template></dom-module>`;document.head.appendChild(a.content);
// EXTERNAL MODULE: ./node_modules/@polymer/polymer/polymer-element.js?babel-target=es6
var o=i("F3iu"),n=i("hLn4"),s=(i("iFZw"),i("8u2h"));
// EXTERNAL MODULE: ./node_modules/@polymer/polymer/lib/utils/gestures.js?babel-target=es6
i("C2xc"),i("GgZ1");
// CONCATENATED MODULE: ./node_modules/@vaadin/vaadin-upload/src/vaadin-upload-icons.js?babel-target=es6
const l=document.createElement("template");l.innerHTML="<custom-style><style>@font-face { font-family: 'vaadin-upload-icons'; src: url(data:application/font-woff;charset=utf-8;base64,d09GRgABAAAAAAasAAsAAAAABmAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAABPUy8yAAABCAAAAGAAAABgDxIF5mNtYXAAAAFoAAAAVAAAAFQXVtKMZ2FzcAAAAbwAAAAIAAAACAAAABBnbHlmAAABxAAAAfQAAAH0bBJxYWhlYWQAAAO4AAAANgAAADYPD267aGhlYQAAA/AAAAAkAAAAJAfCA8tobXR4AAAEFAAAACgAAAAoHgAAx2xvY2EAAAQ8AAAAFgAAABYCSgHsbWF4cAAABFQAAAAgAAAAIAAOADVuYW1lAAAEdAAAAhYAAAIWmmcHf3Bvc3QAAAaMAAAAIAAAACAAAwAAAAMDtwGQAAUAAAKZAswAAACPApkCzAAAAesAMwEJAAAAAAAAAAAAAAAAAAAAARAAAAAAAAAAAAAAAAAAAAAAQAAA6QUDwP/AAEADwABAAAAAAQAAAAAAAAAAAAAAIAAAAAAAAwAAAAMAAAAcAAEAAwAAABwAAwABAAAAHAAEADgAAAAKAAgAAgACAAEAIOkF//3//wAAAAAAIOkA//3//wAB/+MXBAADAAEAAAAAAAAAAAAAAAEAAf//AA8AAQAAAAAAAAAAAAIAADc5AQAAAAABAAAAAAAAAAAAAgAANzkBAAAAAAEAAAAAAAAAAAACAAA3OQEAAAAAAgAA/8AEAAPAABkAMgAAEz4DMzIeAhczLgMjIg4CBycRIScFIRcOAyMiLgInIx4DMzI+AjcXphZGWmo6SH9kQwyADFiGrmJIhXJbIEYBAFoDWv76YBZGXGw8Rn5lRQyADFmIrWBIhHReIkYCWjJVPSIyVnVDXqN5RiVEYTxG/wBa2loyVT0iMlZ1Q16jeUYnRWE5RgAAAAABAIAAAAOAA4AAAgAAExEBgAMAA4D8gAHAAAAAAwAAAAAEAAOAAAIADgASAAAJASElIiY1NDYzMhYVFAYnETMRAgD+AAQA/gAdIyMdHSMjXYADgPyAgCMdHSMjHR0jwAEA/wAAAQANADMD5gNaAAUAACUBNwUBFwHT/jptATMBppMzAU2a4AIgdAAAAAEAOv/6A8YDhgALAAABJwkBBwkBFwkBNwEDxoz+xv7GjAFA/sCMAToBOoz+wAL6jP7AAUCM/sb+xowBQP7AjAE6AAAAAwAA/8AEAAPAAAcACwASAAABFSE1IREhEQEjNTMJAjMRIRECwP6A/sAEAP0AgIACQP7A/sDAAQABQICA/oABgP8AgAHAAUD+wP6AAYAAAAABAAAAAQAAdhiEdV8PPPUACwQAAAAAANX4FR8AAAAA1fgVHwAA/8AEAAPAAAAACAACAAAAAAAAAAEAAAPA/8AAAAQAAAAAAAQAAAEAAAAAAAAAAAAAAAAAAAAKBAAAAAAAAAAAAAAAAgAAAAQAAAAEAACABAAAAAQAAA0EAAA6BAAAAAAAAAAACgAUAB4AagB4AJwAsADSAPoAAAABAAAACgAzAAMAAAAAAAIAAAAAAAAAAAAAAAAAAAAAAAAADgCuAAEAAAAAAAEAEwAAAAEAAAAAAAIABwDMAAEAAAAAAAMAEwBaAAEAAAAAAAQAEwDhAAEAAAAAAAUACwA5AAEAAAAAAAYAEwCTAAEAAAAAAAoAGgEaAAMAAQQJAAEAJgATAAMAAQQJAAIADgDTAAMAAQQJAAMAJgBtAAMAAQQJAAQAJgD0AAMAAQQJAAUAFgBEAAMAAQQJAAYAJgCmAAMAAQQJAAoANAE0dmFhZGluLXVwbG9hZC1pY29ucwB2AGEAYQBkAGkAbgAtAHUAcABsAG8AYQBkAC0AaQBjAG8AbgBzVmVyc2lvbiAxLjAAVgBlAHIAcwBpAG8AbgAgADEALgAwdmFhZGluLXVwbG9hZC1pY29ucwB2AGEAYQBkAGkAbgAtAHUAcABsAG8AYQBkAC0AaQBjAG8AbgBzdmFhZGluLXVwbG9hZC1pY29ucwB2AGEAYQBkAGkAbgAtAHUAcABsAG8AYQBkAC0AaQBjAG8AbgBzUmVndWxhcgBSAGUAZwB1AGwAYQBydmFhZGluLXVwbG9hZC1pY29ucwB2AGEAYQBkAGkAbgAtAHUAcABsAG8AYQBkAC0AaQBjAG8AbgBzRm9udCBnZW5lcmF0ZWQgYnkgSWNvTW9vbi4ARgBvAG4AdAAgAGcAZQBuAGUAcgBhAHQAZQBkACAAYgB5ACAASQBjAG8ATQBvAG8AbgAuAAAAAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA==) format('woff'); font-weight: normal; font-style: normal; }</style></custom-style>",document.head.appendChild(l.content);
// EXTERNAL MODULE: ./node_modules/@vaadin/vaadin-progress-bar/src/vaadin-progress-bar.js?babel-target=es6 + 1 modules
i("vZOv");
// CONCATENATED MODULE: ./node_modules/@vaadin/vaadin-upload/src/vaadin-upload-file.js?babel-target=es6
/**
@license
Copyright (c) 2017 Vaadin Ltd.
This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
*/
/**
 * `<vaadin-upload-file>` element represents a file in the file list of `<vaadin-upload>`.
 *
 * ### Styling
 *
 * The following shadow DOM parts are available for styling:
 *
 * Part name | Description
 * ---|---
 * `row` | File container
 * `info` | Container for file status icon, file name, status and error messages
 * `done-icon` | File done status icon
 * `warning-icon` | File warning status icon
 * `meta` | Container for file name, status and error messages
 * `name` | File name
 * `error` | Error message, shown when error happens
 * `status` | Status message
 * `commands` | Container for file command icons
 * `start-button` | Start file upload button
 * `retry-button` | Retry file upload button
 * `clear-button` | Clear file button
 * `progress`| Progress bar
 *
 * The following state attributes are available for styling:
 *
 * Attribute | Description | Part name
 * ---|---|---
 * `error` | An error has happened during uploading | `:host`
 * `indeterminate` | Uploading is in progress, but the progress value is unknown | `:host`
 * `uploading` | Uploading is in progress | `:host`
 * `complete` | Uploading has finished successfully | `:host`
 *
 * See [ThemableMixin – how to apply styles for shadow parts](https://github.com/vaadin/vaadin-themable-mixin/wiki)
 *
 * @extends PolymerElement
 * @mixes ThemableMixin
 * @demo demo/index.html
 */class d extends(Object(s.a)(o.a)){static get template(){return r.a`<style>:host{display:block}[hidden]{display:none}</style><div part="row"><div part="info"><div part="done-icon" hidden\$="[[!file.complete]]"></div><div part="warning-icon" hidden\$="[[!file.error]]"></div><div part="meta"><div part="name" id="name">[[file.name]]</div><div part="status" hidden\$="[[!file.status]]" id="status">[[file.status]]</div><div part="error" id="error" hidden\$="[[!file.error]]">[[file.error]]</div></div></div><div part="commands"><div part="start-button" file-event="file-start" on-click="_fireFileEvent" hidden\$="[[!file.held]]"></div><div part="retry-button" file-event="file-retry" on-click="_fireFileEvent" hidden\$="[[!file.error]]"></div><div part="clear-button" file-event="file-abort" on-click="_fireFileEvent"></div></div></div><vaadin-progress-bar part="progress" id="progress" value\$="[[_formatProgressValue(file.progress)]]" error\$="[[file.error]]" indeterminate\$="[[file.indeterminate]]" uploading\$="[[file.uploading]]" complete\$="[[file.complete]]"></vaadin-progress-bar>`}static get is(){return"vaadin-upload-file"}static get properties(){return{file:Object}}static get observers(){return["_fileAborted(file.abort)",'_toggleHostAttribute(file.error, "error")','_toggleHostAttribute(file.indeterminate, "indeterminate")','_toggleHostAttribute(file.uploading, "uploading")','_toggleHostAttribute(file.complete, "complete")']}_fileAborted(t){t&&this._remove()}_remove(){this.dispatchEvent(new CustomEvent("file-remove",{detail:{file:this.file},bubbles:!0,composed:!0}))}_formatProgressValue(t){return t/100}_fireFileEvent(t){return t.preventDefault(),this.dispatchEvent(new CustomEvent(t.target.getAttribute("file-event"),{detail:{file:this.file},bubbles:!0,composed:!0}))}_toggleHostAttribute(t,e){const i=Boolean(t);this.hasAttribute(e)!==i&&(i?this.setAttribute(e,""):this.removeAttribute(e))}
/**
  * Fired when the retry button is pressed. It is listened by `vaadin-upload`
  * which will start a new upload process of this file.
  *
  * @event file-retry
  * @param {Object} detail
  * @param {Object} detail.file file to retry upload of
  */
/**
  * Fired when the start button is pressed. It is listened by `vaadin-upload`
  * which will start a new upload process of this file.
  *
  * @event file-start
  * @param {Object} detail
  * @param {Object} detail.file file to start upload of
  */
/**
   * Fired when abort button is pressed. It is listened by `vaadin-upload` which
   * will abort the upload in progress, but will not remove the file from the list
   * to allow the animation to hide the element to be run.
   *
   * @event file-abort
   * @param {Object} detail
   * @param {Object} detail.file file to abort upload of
   */
/**
   * Fired after the animation to hide the element has finished. It is listened
   * by `vaadin-upload` which will actually remove the file from the upload
   * file list.
   *
   * @event file-remove
   * @param {Object} detail
   * @param {Object} detail.file file to remove from the  upload of
   */}customElements.define(d.is,d);
// EXTERNAL MODULE: ./node_modules/@vaadin/vaadin-element-mixin/vaadin-element-mixin.js?babel-target=es6
var A=i("OVu0");
// CONCATENATED MODULE: ./node_modules/@vaadin/vaadin-upload/src/vaadin-upload.js?babel-target=es6
/**
@license
Copyright (c) 2017 Vaadin Ltd.
This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
*/
/**
 * `<vaadin-upload>` is a Web Component for uploading multiple files with drag and drop support.
 *
 * Example:
 *
 * ```
 * <vaadin-upload></vaadin-upload>
 * ```
 *
 * ### Styling
 *
 * The following shadow DOM parts are available for styling:
 *
 * Part name | Description
 * ---|---
 * `primary-buttons` | Upload container
 * `upload-button` | Upload button
 * `drop-label` | Label for drop indicator
 * `drop-label-icon` | Icon for drop indicator
 * `file-list` | File list container
 *
 * The following state attributes are available for styling:
 *
 * Attribute | Description | Part name
 * ---|---|---
 * `nodrop` | Set when drag and drop is disabled (e. g., on touch devices) | `:host`
 * `dragover` | A file is being dragged over the element | `:host`
 * `dragover-valid` | A dragged file is valid with `maxFiles` and `accept` criteria | `:host`
 * `max-files-reached` | The maximum number of files that the user is allowed to add to the upload has been reached | `:host`
 *
 * See [ThemableMixin – how to apply styles for shadow parts](https://github.com/vaadin/vaadin-themable-mixin/wiki)
 *
 * @extends PolymerElement
 * @mixes ThemableMixin
 * @mixes ElementMixin
 * @demo demo/index.html
 */class h extends(Object(A.a)(Object(s.a)(o.a))){static get template(){return r.a`<style>:host{display:block;position:relative}:host([hidden]){display:none!important}[hidden]{display:none!important}</style><div part="primary-buttons"><div id="addFiles" on-touchend="_onAddFilesTouchEnd" on-click="_onAddFilesClick"><slot name="add-button"><vaadin-button part="upload-button" id="addButton" disabled="[[maxFilesReached]]">[[_i18nPlural(maxFiles, i18n.addFiles, i18n.addFiles.*)]]</vaadin-button></slot></div><div part="drop-label" hidden\$="[[nodrop]]" id="dropLabelContainer"><slot name="drop-label-icon"><div part="drop-label-icon"></div></slot><slot name="drop-label" id="dropLabel">[[_i18nPlural(maxFiles, i18n.dropFiles, i18n.dropFiles.*)]]</slot></div></div><slot name="file-list"><div id="fileList" part="file-list"><template is="dom-repeat" items="[[files]]" as="file"><vaadin-upload-file file="[[file]]"></vaadin-upload-file></template></div></slot><slot></slot><input type="file" id="fileInput" on-change="_onFileInputChange" hidden="" accept\$="{{accept}}" multiple\$="[[_isMultiple(maxFiles)]]" capture\$="[[capture]]">`}static get is(){return"vaadin-upload"}static get version(){return"4.4.3"}static get properties(){return{
/**
       * Define whether the element supports dropping files on it for uploading.
       * By default it's enabled in desktop and disabled in touch devices
       * because mobile devices do not support drag events in general. Setting
       * it false means that drop is enabled even in touch-devices, and true
       * disables drop in all devices.
       *
       * @type {boolean}
       * @default true in touch-devices, false otherwise.
       */
nodrop:{type:Boolean,reflectToAttribute:!0,value:function(){try{return!!document.createEvent("TouchEvent")}catch(t){return!1}}},
/**
       * The server URL. The default value is an empty string, which means that
       * _window.location_ will be used.
       * @type {string}
       */
target:{type:String,value:""},
/**
       * HTTP Method used to send the files. Only POST and PUT are allowed.
       * @type {!UploadMethod}
       */
method:{type:String,value:"POST"},
/**
       * Key-Value map to send to the server. If you set this property as an
       * attribute, use a valid JSON string, for example:
       * ```
       * <vaadin-upload headers='{"X-Foo": "Bar"}'></vaadin-upload>
       * ```
       * @type {object | string}
       */
headers:{type:Object,value:{}},
/**
       * Max time in milliseconds for the entire upload process, if exceeded the
       * request will be aborted. Zero means that there is no timeout.
       * @type {number}
       */
timeout:{type:Number,value:0},
/** @private */
_dragover:{type:Boolean,value:!1,observer:"_dragoverChanged"},
/**
       * The array of files being processed, or already uploaded.
       *
       * Each element is a [`File`](https://developer.mozilla.org/en-US/docs/Web/API/File)
       * object with a number of extra properties  to track the upload process:
       * - `uploadTarget`: The target URL used to upload this file.
       * - `elapsed`: Elapsed time since the upload started.
       * - `elapsedStr`: Human-readable elapsed time.
       * - `remaining`: Number of seconds remaining for the upload to finish.
       * - `remainingStr`: Human-readable remaining time for the upload to finish.
       * - `progress`: Percentage of the file already uploaded.
       * - `speed`: Upload speed in kB/s.
       * - `size`: File size in bytes.
       * - `totalStr`: Human-readable total size of the file.
       * - `loaded`: Bytes transferred so far.
       * - `loadedStr`: Human-readable uploaded size at the moment.
       * - `status`: Status of the upload process.
       * - `error`: Error message in case the upload failed.
       * - `abort`: True if the file was canceled by the user.
       * - `complete`: True when the file was transferred to the server.
       * - `uploading`: True while transferring data to the server.
       * @type {!Array<!UploadFile>}
       */
files:{type:Array,notify:!0,value:function(){return[]}},
/**
       * Limit of files to upload, by default it is unlimited. If the value is
       * set to one, native file browser will prevent selecting multiple files.
       * @attr {number} max-files
       * @type {number}
       */
maxFiles:{type:Number,value:1/0},
/**
       * Specifies if the maximum number of files have been uploaded
       * @attr {boolean} max-files-reached
       * @type {boolean}
       */
maxFilesReached:{type:Boolean,value:!1,notify:!0,readOnly:!0,reflectToAttribute:!0,computed:"_maxFilesAdded(maxFiles, files.length)"},
/**
       * Specifies the types of files that the server accepts.
       * Syntax: a comma-separated list of MIME type patterns (wildcards are
       * allowed) or file extensions.
       * Notice that MIME types are widely supported, while file extensions
       * are only implemented in certain browsers, so avoid using it.
       * Example: accept="video/*,image/tiff" or accept=".pdf,audio/mp3"
       * @type {string}
       */
accept:{type:String,value:""},
/**
       * Specifies the maximum file size in bytes allowed to upload.
       * Notice that it is a client-side constraint, which will be checked before
       * sending the request. Obviously you need to do the same validation in
       * the server-side and be sure that they are aligned.
       * @attr {number} max-file-size
       * @type {number}
       */
maxFileSize:{type:Number,value:1/0},
/**
       * Specifies if the dragover is validated with maxFiles and
       * accept properties.
       * @private
       */
_dragoverValid:{type:Boolean,value:!1,observer:"_dragoverValidChanged"},
/**
       * Specifies the 'name' property at Content-Disposition
       * @attr {string} form-data-name
       * @type {string}
       */
formDataName:{type:String,value:"file"},
/**
       * Prevents upload(s) from immediately uploading upon adding file(s).
       * When set, you must manually trigger uploads using the `uploadFiles` method
       * @attr {boolean} no-auto
       * @type {boolean}
       */
noAuto:{type:Boolean,value:!1},
/**
       * Set the withCredentials flag on the request.
       * @attr {boolean} with-credentials
       * @type {boolean}
       */
withCredentials:{type:Boolean,value:!1},
/**
       * Pass-through to input's capture attribute. Allows user to trigger device inputs
       * such as camera or microphone immediately.
       */
capture:String,
/**
       * The object used to localize this component.
       * For changing the default localization, change the entire
       * _i18n_ object or just the property you want to modify.
       *
       * The object has the following JSON structure and default values:
       {
        dropFiles: {
        one: 'Drop file here
        many: 'Drop files here
        },
        addFiles: {
        one: 'Select File...',
        many: 'Upload Files...'
        },
        cancel: 'Cancel',
        error: {
        tooManyFiles: 'Too Many Files.',
        fileIsTooBig: 'File is Too Big.',
        incorrectFileType: 'Incorrect File Type.'
        },
        uploading: {
        status: {
          connecting: 'Connecting...',
          stalled: 'Stalled',
          processing: 'Processing File...',
          held: 'Queued'
        },
        remainingTime: {
          prefix: 'remaining time: ',
          unknown: 'unknown remaining time'
        },
        error: {
          serverUnavailable: 'Server Unavailable',
          unexpectedServerError: 'Unexpected Server Error',
          forbidden: 'Forbidden'
        }
        },
        units: {
        size: ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
        sizeBase: 1000
        },
        formatSize: function(bytes) {
        // returns the size followed by the best suitable unit
        },
        formatTime: function(seconds, [secs, mins, hours]) {
        // returns a 'HH:MM:SS' string
        }
      }
       * @type {!UploadI18n}
      * @default {English}
      */
i18n:{type:Object,value:function(){return{dropFiles:{one:"Drop file here",many:"Drop files here"},addFiles:{one:"Upload File...",many:"Upload Files..."},cancel:"Cancel",error:{tooManyFiles:"Too Many Files.",fileIsTooBig:"File is Too Big.",incorrectFileType:"Incorrect File Type."},uploading:{status:{connecting:"Connecting...",stalled:"Stalled.",processing:"Processing File...",held:"Queued"},remainingTime:{prefix:"remaining time: ",unknown:"unknown remaining time"},error:{serverUnavailable:"Server Unavailable",unexpectedServerError:"Unexpected Server Error",forbidden:"Forbidden"}},units:{size:["B","kB","MB","GB","TB","PB","EB","ZB","YB"]}}}}}}
/** @protected */ready(){super.ready(),this.addEventListener("dragover",this._onDragover.bind(this)),this.addEventListener("dragleave",this._onDragleave.bind(this)),this.addEventListener("drop",this._onDrop.bind(this)),this.addEventListener("file-retry",this._onFileRetry.bind(this)),this.addEventListener("file-abort",this._onFileAbort.bind(this)),this.addEventListener("file-remove",this._onFileRemove.bind(this)),this.addEventListener("file-start",this._onFileStart.bind(this))}
/** @private */_formatSize(t){if("function"==typeof this.i18n.formatSize)return this.i18n.formatSize(t);// https://wiki.ubuntu.com/UnitsPolicy
const e=this.i18n.units.sizeBase||1e3,i=~~(Math.log(t)/Math.log(e)),r=Math.max(0,Math.min(3,i-1));return parseFloat((t/Math.pow(e,i)).toFixed(r))+" "+this.i18n.units.size[i]}
/** @private */_splitTimeByUnits(t){const e=[60,60,24,1/0],i=[0];for(var r=0;r<e.length&&t>0;r++)i[r]=t%e[r],t=Math.floor(t/e[r]);return i}
/** @private */_formatTime(t,e){if("function"==typeof this.i18n.formatTime)return this.i18n.formatTime(t,e);// Fill HH:MM:SS with leading zeros
for(;e.length<3;)e.push(0);return e.reverse().map(t=>(t<10?"0":"")+t).join(":")}
/** @private */_formatFileProgress(t){return t.totalStr+": "+t.progress+"% ("+(t.loaded>0?this.i18n.uploading.remainingTime.prefix+t.remainingStr:this.i18n.uploading.remainingTime.unknown)+")"}
/** @private */_maxFilesAdded(t,e){return t>=0&&e>=t}
/** @private */_onDragover(t){t.preventDefault(),this.nodrop||this._dragover||(this._dragoverValid=!this.maxFilesReached,this._dragover=!0),t.dataTransfer.dropEffect=!this._dragoverValid||this.nodrop?"none":"copy"}
/** @private */_onDragleave(t){t.preventDefault(),this._dragover&&!this.nodrop&&(this._dragover=this._dragoverValid=!1)}
/** @private */_onDrop(t){this.nodrop||(t.preventDefault(),this._dragover=this._dragoverValid=!1,this._addFiles(t.dataTransfer.files))}
/** @private */_createXhr(){return new XMLHttpRequest}
/** @private */_configureXhr(t){if("string"==typeof this.headers)try{this.headers=JSON.parse(this.headers)}catch(t){this.headers=void 0}for(var e in this.headers)t.setRequestHeader(e,this.headers[e]);this.timeout&&(t.timeout=this.timeout),t.withCredentials=this.withCredentials}
/** @private */_setStatus(t,e,i,r){t.elapsed=r,t.elapsedStr=this._formatTime(t.elapsed,this._splitTimeByUnits(t.elapsed)),t.remaining=Math.ceil(r*(e/i-1)),t.remainingStr=this._formatTime(t.remaining,this._splitTimeByUnits(t.remaining)),t.speed=~~(e/r/1024),t.totalStr=this._formatSize(e),t.loadedStr=this._formatSize(i),t.status=this._formatFileProgress(t)}
/**
   * Triggers the upload of any files that are not completed
   *
   * @param {!UploadFile | !Array<!UploadFile>=} files - Files being uploaded. Defaults to all outstanding files
   */uploadFiles(t){t&&!Array.isArray(t)&&(t=[t]),t=(t=t||this.files).filter(t=>!t.complete),Array.prototype.forEach.call(t,this._uploadFile.bind(this))}
/** @private */_uploadFile(t){if(t.uploading)return;const e=Date.now(),i=t.xhr=this._createXhr();let r,a;// onprogress is called always after onreadystatechange
i.upload.onprogress=o=>{clearTimeout(r),a=Date.now();const n=(a-e)/1e3,s=o.loaded,l=o.total,d=~~(s/l*100);t.loaded=s,t.progress=d,t.indeterminate=s<=0||s>=l,t.error?t.indeterminate=t.status=void 0:t.abort||(d<100?(this._setStatus(t,l,s,n),r=setTimeout(()=>{t.status=this.i18n.uploading.status.stalled,this._notifyFileChanges(t)},2e3)):(t.loadedStr=t.totalStr,t.status=this.i18n.uploading.status.processing)),this._notifyFileChanges(t),this.dispatchEvent(new CustomEvent("upload-progress",{detail:{file:t,xhr:i}}))},// More reliable than xhr.onload
i.onreadystatechange=()=>{if(4==i.readyState){if(clearTimeout(r),t.indeterminate=t.uploading=!1,t.abort)return void this._notifyFileChanges(t);t.status="";if(!this.dispatchEvent(new CustomEvent("upload-response",{detail:{file:t,xhr:i},cancelable:!0})))return;0===i.status?t.error=this.i18n.uploading.error.serverUnavailable:i.status>=500?t.error=this.i18n.uploading.error.unexpectedServerError:i.status>=400&&(t.error=this.i18n.uploading.error.forbidden),t.complete=!t.error,this.dispatchEvent(new CustomEvent("upload-"+(t.error?"error":"success"),{detail:{file:t,xhr:i}})),this._notifyFileChanges(t)}};const o=new FormData;t.uploadTarget=t.uploadTarget||this.target||"",t.formDataName=this.formDataName;if(!this.dispatchEvent(new CustomEvent("upload-before",{detail:{file:t,xhr:i},cancelable:!0})))return;o.append(t.formDataName,t,t.name),i.open(this.method,t.uploadTarget,!0),this._configureXhr(i),t.status=this.i18n.uploading.status.connecting,t.uploading=t.indeterminate=!0,t.complete=t.abort=t.error=t.held=!1,i.upload.onloadstart=()=>{this.dispatchEvent(new CustomEvent("upload-start",{detail:{file:t,xhr:i}})),this._notifyFileChanges(t)};this.dispatchEvent(new CustomEvent("upload-request",{detail:{file:t,xhr:i,formData:o},cancelable:!0}))&&i.send(o)}
/** @private */_retryFileUpload(t){this.dispatchEvent(new CustomEvent("upload-retry",{detail:{file:t,xhr:t.xhr},cancelable:!0}))&&this._uploadFile(t)}
/** @private */_abortFileUpload(t){this.dispatchEvent(new CustomEvent("upload-abort",{detail:{file:t,xhr:t.xhr},cancelable:!0}))&&(t.abort=!0,t.xhr&&t.xhr.abort(),this._notifyFileChanges(t))}
/** @private */_notifyFileChanges(t){var e="files."+this.files.indexOf(t)+".";for(var i in t)t.hasOwnProperty(i)&&this.notifyPath(e+i,t[i])}
/** @private */_addFiles(t){Array.prototype.forEach.call(t,this._addFile.bind(this))}
/**
   * Add the file for uploading. Called internally for each file after picking files from dialog or dropping files.
   *
   * @param {!UploadFile} file File being added
   * @protected
   */_addFile(t){if(this.maxFilesReached)return void this.dispatchEvent(new CustomEvent("file-reject",{detail:{file:t,error:this.i18n.error.tooManyFiles}}));if(this.maxFileSize>=0&&t.size>this.maxFileSize)return void this.dispatchEvent(new CustomEvent("file-reject",{detail:{file:t,error:this.i18n.error.fileIsTooBig}}));const e=t.name.match(/\.[^\.]*$|$/)[0],i=new RegExp("^("+this.accept.replace(/[, ]+/g,"|").replace(/\/\*/g,"/.*")+")$","i");!this.accept||i.test(t.type)||i.test(e)?(t.loaded=0,t.held=!0,t.status=this.i18n.uploading.status.held,this.unshift("files",t),this.noAuto||this._uploadFile(t)):this.dispatchEvent(new CustomEvent("file-reject",{detail:{file:t,error:this.i18n.error.incorrectFileType}}))}
/**
   * Remove file from upload list. Called internally if file upload was canceled.
   * @param {!UploadFile} file File to remove
   * @protected
   */_removeFile(t){this.files.indexOf(t)>-1&&this.splice("files",this.files.indexOf(t),1)}
/** @private */_onAddFilesTouchEnd(t){
// Cancel the event to avoid the following click event
t.preventDefault(),// FIXME(platosha): workaround for Polymer Gestures mouseCanceller
// cancelling the following synthetic click. See also:
// https://github.com/Polymer/polymer/issues/5289
this.__resetMouseCanceller(),this._onAddFilesClick()}
/** @private */__resetMouseCanceller(){Object(n.f)()}
/** @private */_onAddFilesClick(){this.maxFilesReached||(this.$.fileInput.value="",this.$.fileInput.click())}
/** @private */_onFileInputChange(t){this._addFiles(t.target.files)}
/** @private */_onFileStart(t){this._uploadFile(t.detail.file)}
/** @private */_onFileRetry(t){this._retryFileUpload(t.detail.file)}
/** @private */_onFileAbort(t){this._abortFileUpload(t.detail.file)}
/** @private */_onFileRemove(t){this._removeFile(t.detail.file)}
/** @private */_dragoverChanged(t){t?this.setAttribute("dragover",t):this.removeAttribute("dragover")}
/** @private */_dragoverValidChanged(t){t?this.setAttribute("dragover-valid",t):this.removeAttribute("dragover-valid")}
/** @private */_i18nPlural(t,e){return 1==t?e.one:e.many}
/** @private */_isMultiple(t){return 1!=t}
/**
  * Fired when a file cannot be added to the queue due to a constrain:
  *  file-size, file-type or maxFiles
  *
  * @event file-reject
  * @param {Object} detail
  * @param {Object} detail.file the file added
  * @param {string} detail.error the cause
  */
/**
  * Fired before the XHR is opened. Could be used for changing the request
  * URL. If the default is prevented, then XHR would not be opened.
  *
  * @event upload-before
  * @param {Object} detail
  * @param {Object} detail.xhr the xhr
  * @param {Object} detail.file the file being uploaded
  * @param {Object} detail.file.uploadTarget the upload request URL, initialized with the value of vaadin-upload `target` property
  */
/**
  * Fired when the XHR has been opened but not sent yet. Useful for appending
  * data keys to the FormData object, for changing some parameters like
  * headers, etc. If the event is defaultPrevented, `vaadin-upload` will not
  * send the request allowing the user to do something on his own.
  *
  * @event upload-request
  * @param {Object} detail
  * @param {Object} detail.xhr the xhr
  * @param {Object} detail.file the file being uploaded
  * @param {Object} detail.formData the FormData object
  */
/**
  * Fired when the XHR is sent.
  *
  * @event upload-start
  * @param {Object} detail
  * @param {Object} detail.xhr the xhr
  * @param {Object} detail.file the file being uploaded
  */
/**
  * Fired as many times as the progress is updated.
  *
  * @event upload-progress
  * @param {Object} detail
  * @param {Object} detail.xhr the xhr
  * @param {Object} detail.file the file being uploaded with loaded info
  */
/**
  * Fired when we have the actual server response, and before the component
  * analyses it. It's useful for developers to make the upload fail depending
  * on the server response. If the event is defaultPrevented the vaadin-upload
  * will return allowing the user to do something on his own like retry the
  * upload, etc. since he has full access to the `xhr` and `file` objects.
  * Otherwise, if the event is not prevented default `vaadin-upload` continues
  * with the normal workflow checking the `xhr.status` and `file.error`
  * which also might be modified by the user to force a customized response.
  *
  * @event upload-response
  * @param {Object} detail
  * @param {Object} detail.xhr the xhr
  * @param {Object} detail.file the file being uploaded
  */
/**
  * Fired in case the upload process succeed.
  *
  * @event upload-success
  * @param {Object} detail
  * @param {Object} detail.xhr the xhr
  * @param {Object} detail.file the file being uploaded with loaded info
  */
/**
  * Fired in case the upload process failed.
  *
  * @event upload-error
  * @param {Object} detail
  * @param {Object} detail.xhr the xhr
  * @param {Object} detail.file the file being uploaded
  */
/**
  * Fired when retry upload is requested. If the default is prevented, then
  * retry would not be performed.
  *
  * @event upload-retry
  * @param {Object} detail
  * @param {Object} detail.xhr the previous upload xhr
  * @param {Object} detail.file the file being uploaded
  */
/**
  * Fired when retry abort is requested. If the default is prevented, then the
  * file upload would not be aborted.
  *
  * @event upload-abort
  * @param {Object} detail
  * @param {Object} detail.xhr the xhr
  * @param {Object} detail.file the file being uploaded
  */}customElements.define(h.is,h)},
/***/"7vYi":
/***/function(t,e,i){"use strict";
/* harmony export (binding) */i.d(e,"a",(function(){return d}));
/* harmony import */var r=i("F3iu"),a=i("wZOt"),o=i("6kUO"),n=i("8u2h"),s=i("OVu0"),l=i("o5Wi");
/* harmony import */
/**
@license
Copyright (c) 2017 Vaadin Ltd.
This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
*/
/**
 * `<vaadin-text-field>` is a Web Component for text field control in forms.
 *
 * ```html
 * <vaadin-text-field label="First Name">
 * </vaadin-text-field>
 * ```
 *
 * ### Prefixes and suffixes
 *
 * These are child elements of a `<vaadin-text-field>` that are displayed
 * inline with the input, before or after.
 * In order for an element to be considered as a prefix, it must have the slot
 * attribute set to `prefix` (and similarly for `suffix`).
 *
 * ```html
 * <vaadin-text-field label="Email address">
 *   <div slot="prefix">Sent to:</div>
 *   <div slot="suffix">@vaadin.com</div>
 * </vaadin-text-area>
 * ```
 *
 * ### Styling
 *
 * The following custom properties are available for styling:
 *
 * Custom property | Description | Default
 * ----------------|-------------|-------------
 * `--vaadin-text-field-default-width` | Set the default width of the input field | `12em`
 *
 * The following shadow DOM parts are available for styling:
 *
 * Part name | Description
 * ----------------|----------------
 * `label` | The label element
 * `input-field` | The element that wraps prefix, value and suffix
 * `value` | The text value element inside the `input-field` element
 * `error-message` | The error message element
 *
 * The following state attributes are available for styling:
 *
 * Attribute    | Description | Part name
 * -------------|-------------|------------
 * `disabled` | Set to a disabled text field | :host
 * `has-value` | Set when the element has a value | :host
 * `has-label` | Set when the element has a label | :host
 * `has-helper` | Set when the element has helper text or slot | :host
 * `has-error-message` | Set when the element has an error message | :host
 * `invalid` | Set when the element is invalid | :host
 * `input-prevented` | Temporarily set when invalid input is prevented | :host
 * `focused` | Set when the element is focused | :host
 * `focus-ring` | Set when the element is keyboard focused | :host
 * `readonly` | Set to a readonly text field | :host
 *
 * See [ThemableMixin – how to apply styles for shadow parts](https://github.com/vaadin/vaadin-themable-mixin/wiki)
 *
 * @extends PolymerElement
 * @mixes TextFieldMixin
 * @mixes ControlStateMixin
 * @mixes ThemableMixin
 * @mixes ElementMixin
 * @demo demo/index.html
 */
class d extends(Object(s.a)(Object(a.a)(Object(o.a)(Object(n.a)(r.a))))){static get template(){return l.a`<style include="vaadin-text-field-shared-styles"></style><div class="vaadin-text-field-container"><label part="label" on-click="focus" id="[[_labelId]]">[[label]]</label><div part="input-field" id="[[_inputId]]"><slot name="prefix"></slot><slot name="input"><input part="value"></slot><div part="clear-button" id="clearButton" role="button" aria-label\$="[[i18n.clear]]"></div><slot name="suffix"></slot></div><div part="helper-text" id="[[_helperTextId]]"><slot name="helper">[[helperText]]</slot></div><div part="error-message" id="[[_errorId]]" aria-live="assertive" aria-hidden\$="[[_getErrorMessageAriaHidden(invalid, errorMessage, _errorId)]]">[[errorMessage]]</div></div>`}static get is(){return"vaadin-text-field"}static get version(){return"2.9.1"}static get properties(){return{
/**
       * Identifies a list of pre-defined options to suggest to the user.
       * The value must be the id of a <datalist> element in the same document.
       */
list:{type:String},
/**
       * A regular expression that the value is checked against.
       * The pattern must match the entire value, not just some subset.
       */
pattern:{type:String},
/**
       * The text usually displayed in a tooltip popup when the mouse is over the field.
       * @type {string}
       */
title:{type:String}}}}customElements.define(d.is,d)},
/***/"8u2h":
/***/function(t,e,i){"use strict";
/* harmony export (binding) */i.d(e,"a",(function(){return o}));
/* harmony import */var r=i("O5q1"),a=i("bjSq");
/* harmony import */
/**
 * @polymerMixin
 * @mixes ThemePropertyMixin
 */
const o=t=>class extends(Object(a.a)(t)){
/** @protected */
static finalize(){super.finalize();const t=this.prototype._template,e=this.template&&this.template.parentElement&&this.template.parentElement.id===this.is,i=Object.getPrototypeOf(this.prototype)._template;i&&!e&&
// The element doesn't define its own template -> include the theme modules from the inherited template
Array.from(i.content.querySelectorAll("style[include]")).forEach(e=>{this._includeStyle(e.getAttribute("include"),t)}),this._includeMatchingThemes(t)}
/** @private */static _includeMatchingThemes(t){const e=r.a.prototype.modules;let i=!1;const a=this.is+"-default-theme";Object.keys(e).sort((t,e)=>{const i=0===t.indexOf("vaadin-"),r=0===e.indexOf("vaadin-"),a=["lumo-","material-"],o=a.filter(e=>0===t.indexOf(e)).length>0,n=a.filter(t=>0===e.indexOf(t)).length>0;return i!==r?i?-1:1:o!==n?o?-1:1:0}).forEach(r=>{if(r!==a){const a=e[r].getAttribute("theme-for");a&&a.split(" ").forEach(e=>{new RegExp("^"+e.split("*").join(".*")+"$").test(this.is)&&(i=!0,this._includeStyle(r,t))})}}),!i&&e[a]&&
// No theme modules found, include the default module if it exists
this._includeStyle(a,t)}
/** @private */static _includeStyle(t,e){if(e&&!e.content.querySelector(`style[include="${t}"]`)){const i=document.createElement("style");i.setAttribute("include",t),e.content.appendChild(i)}}}
/***/},
/***/CThD:
/***/function(t,e,i){"use strict";
// EXTERNAL MODULE: ./node_modules/@vaadin/vaadin-lumo-styles/color.js?babel-target=es6
i("h/KH"),i("70OO"),i("fBRI"),i("y+0W"),i("7L45"),i("87O/"),i("XZNo"),i("zCHs");
// EXTERNAL MODULE: ./node_modules/@vaadin/vaadin-lumo-styles/sizing.js?babel-target=es6
// CONCATENATED MODULE: ./node_modules/@vaadin/vaadin-text-field/theme/lumo/vaadin-text-field-styles.js?babel-target=es6
const r=i("o5Wi").a`<dom-module id="lumo-text-field" theme-for="vaadin-text-field"><template><style include="lumo-required-field lumo-field-button">:host{--lumo-text-field-size:var(--lumo-size-m);color:var(--lumo-body-text-color);font-size:var(--lumo-font-size-m);font-family:var(--lumo-font-family);-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;-webkit-tap-highlight-color:transparent;padding:var(--lumo-space-xs) 0}:host::before{height:var(--lumo-text-field-size);box-sizing:border-box;display:inline-flex;align-items:center}:host([focused]:not([readonly])) [part=label]{color:var(--lumo-primary-text-color)}:host([has-helper]) [part=helper-text]::before{content:"";display:block;height:.4em}[part=helper-text],[part=helper-text] ::slotted(*){display:block;color:var(--lumo-secondary-text-color);font-size:var(--lumo-font-size-xs);line-height:var(--lumo-line-height-xs);margin-left:calc(var(--lumo-border-radius-m)/ 4);transition:color .2s}[part=input-field] ::slotted([part=value]),[part=input-field] ::slotted(input),[part=input-field] ::slotted(textarea),[part=value]{cursor:inherit;min-height:var(--lumo-text-field-size);padding:0 .25em;--_lumo-text-field-overflow-mask-image:linear-gradient(to left, transparent, #000 1.25em);-webkit-mask-image:var(--_lumo-text-field-overflow-mask-image)}:host([focused]) [part=input-field] ::slotted(input),:host([focused]) [part=input-field] ::slotted(textarea),[part=value]:focus{-webkit-mask-image:none;mask-image:none}@-moz-document url-prefix(){[part=input-field] ::slotted([part=value]),[part=input-field] ::slotted(input),[part=input-field] ::slotted(textarea),[part=value]{mask-image:var(--_lumo-text-field-overflow-mask-image)}}[part=value]::-webkit-input-placeholder{color:inherit;transition:opacity 175ms 50ms;opacity:.5}[part=value]:-ms-input-placeholder{color:inherit;opacity:.5}[part=value]::-moz-placeholder{color:inherit;transition:opacity 175ms 50ms;opacity:.5}[part=value]::placeholder{color:inherit;transition:opacity 175ms .1s;opacity:.5}[part=input-field]{border-radius:var(--lumo-border-radius);background-color:var(--lumo-contrast-10pct);padding:0 calc(.375em + var(--lumo-border-radius)/ 4 - 1px);font-weight:500;line-height:1;position:relative;cursor:text;box-sizing:border-box}[part=input-field]::after{content:"";position:absolute;top:0;right:0;bottom:0;left:0;border-radius:inherit;pointer-events:none;background-color:var(--lumo-contrast-50pct);opacity:0;transition:transform .15s,opacity .2s;transform-origin:100% 0}:host(:hover:not([readonly])) [part=helper-text],:host(:hover:not([readonly])) [part=helper-text] ::slotted(*),:host(:hover:not([readonly]):not([focused])) [part=label]{color:var(--lumo-body-text-color)}:host(:hover:not([readonly]):not([focused])) [part=input-field]::after{opacity:.1}@media (pointer:coarse){:host(:hover:not([readonly]):not([focused])) [part=label]{color:var(--lumo-secondary-text-color)}:host(:hover:not([readonly]):not([focused])) [part=input-field]::after{opacity:0}:host(:active:not([readonly]):not([focused])) [part=input-field]::after{opacity:.2}}:host([focused]:not([focus-ring]):not([readonly])) [part=input-field]::after{transform:scaleX(0);transition-duration:.15s,1s}:host([focus-ring]) [part=input-field]{box-shadow:0 0 0 2px var(--lumo-primary-color-50pct)}:host([disabled]) [part=value]::-webkit-input-placeholder,:host([readonly]) [part=value]::-webkit-input-placeholder{opacity:0}:host([disabled]) [part=value]:-ms-input-placeholder,:host([readonly]) [part=value]:-ms-input-placeholder{opacity:0}:host([disabled]) [part=value]::-moz-placeholder,:host([readonly]) [part=value]::-moz-placeholder{opacity:0}:host([disabled]) [part=value]::placeholder,:host([readonly]) [part=value]::placeholder{opacity:0}:host([readonly]) [part=input-field]{color:var(--lumo-secondary-text-color);background-color:transparent;cursor:default}:host([readonly]) [part=input-field]::after{background-color:transparent;opacity:1;border:1px dashed var(--lumo-contrast-30pct)}:host([disabled]){pointer-events:none}:host([disabled]) [part=input-field]{background-color:var(--lumo-contrast-5pct)}:host([disabled]) [part=helper-text],:host([disabled]) [part=input-field] ::slotted(*),:host([disabled]) [part=label],:host([disabled]) [part=value]{color:var(--lumo-disabled-text-color);-webkit-text-fill-color:var(--lumo-disabled-text-color)}:host([invalid]) [part=input-field]{background-color:var(--lumo-error-color-10pct)}:host([invalid]) [part=input-field]::after{background-color:var(--lumo-error-color-50pct)}:host([invalid][focus-ring]) [part=input-field]{box-shadow:0 0 0 2px var(--lumo-error-color-50pct)}:host([input-prevented]) [part=input-field]{color:var(--lumo-error-text-color)}:host([theme~=small]){font-size:var(--lumo-font-size-s);--lumo-text-field-size:var(--lumo-size-s)}:host([theme~=small][has-label]) [part=label]{font-size:var(--lumo-font-size-xs)}:host([theme~=small][has-label]) [part=error-message]{font-size:var(--lumo-font-size-xxs)}:host([theme~=align-left]) [part=value]{text-align:left;--_lumo-text-field-overflow-mask-image:none}:host([theme~=align-center]) [part=value]{text-align:center;--_lumo-text-field-overflow-mask-image:none}:host([theme~=align-right]) [part=value]{text-align:right;--_lumo-text-field-overflow-mask-image:none}@-moz-document url-prefix(){:host([theme~=align-right]) [part=value]{--_lumo-text-field-overflow-mask-image:linear-gradient(to right, transparent 0.25em, #000 1.5em)}}@-moz-document url-prefix(){:host([theme~=align-left]) [part=value]{--_lumo-text-field-overflow-mask-image:linear-gradient(to left, transparent 0.25em, #000 1.5em)}}:host([has-helper][theme~=helper-above-field]) [part=helper-text]::before{display:none}:host([has-helper][theme~=helper-above-field]) [part=helper-text]::after{content:"";display:block;height:.4em}:host([has-helper][theme~=helper-above-field]) [part=label]{order:0;padding-bottom:.4em}:host([has-helper][theme~=helper-above-field]) [part=helper-text]{order:1}:host([has-helper][theme~=helper-above-field]) [part=input-field]{order:2}:host([has-helper][theme~=helper-above-field]) [part=error-message]{order:3}[part=input-field] ::slotted(:not([part]):not(iron-icon):not(input):not(textarea)){color:var(--lumo-secondary-text-color);font-weight:400}[part=input-field] ::slotted(iron-icon){color:var(--lumo-contrast-60pct);width:var(--lumo-icon-size-m);height:var(--lumo-icon-size-m)}[part=input-field] ::slotted(iron-icon[icon^="vaadin:"]){padding:.25em;box-sizing:border-box!important}[part=clear-button]::before{content:var(--lumo-icons-cross)}:host([dir=rtl]) [part=input-field]::after{transform-origin:0 0}:host([dir=rtl]) [part=input-field] ::slotted(input),:host([dir=rtl]) [part=input-field] ::slotted(textarea),:host([dir=rtl]) [part=value]{--_lumo-text-field-overflow-mask-image:linear-gradient(to right, transparent, #000 1.25em)}:host([dir=rtl]) [part=value]:focus,:host([focused][dir=rtl]) [part=input-field] ::slotted(input),:host([focused][dir=rtl]) [part=input-field] ::slotted(textarea){-webkit-mask-image:none;mask-image:none}@-moz-document url-prefix(){:host([dir=rtl]) [part=input-field] ::slotted([part=value]),:host([dir=rtl]) [part=input-field] ::slotted(input),:host([dir=rtl]) [part=input-field] ::slotted(textarea),:host([dir=rtl]) [part=value]{mask-image:var(--_lumo-text-field-overflow-mask-image)}}:host([theme~=align-left][dir=rtl]) [part=value]{--_lumo-text-field-overflow-mask-image:none}:host([theme~=align-center][dir=rtl]) [part=value]{--_lumo-text-field-overflow-mask-image:none}:host([theme~=align-right][dir=rtl]) [part=value]{--_lumo-text-field-overflow-mask-image:none}@-moz-document url-prefix(){:host([theme~=align-right][dir=rtl]) [part=value]{--_lumo-text-field-overflow-mask-image:linear-gradient(to right, transparent 0.25em, #000 1.5em)}}@-moz-document url-prefix(){:host([theme~=align-left][dir=rtl]) [part=value]{--_lumo-text-field-overflow-mask-image:linear-gradient(to left, transparent 0.25em, #000 1.5em)}}</style></template></dom-module>`;document.head.appendChild(r.content);
// EXTERNAL MODULE: ./node_modules/@vaadin/vaadin-text-field/src/vaadin-text-field.js?babel-target=es6
i("7vYi");
// CONCATENATED MODULE: ./node_modules/@vaadin/vaadin-text-field/theme/lumo/vaadin-text-field.js?babel-target=es6
/***/},
/***/Lg99:
/***/function(t,e,i){"use strict";
/* harmony export (binding) */i.d(e,"a",(function(){return n}));
/* harmony import */i("O5q1");
/* harmony import */var r=i("Rukz");let a=0;// Map of <CSSResult, Polymer.DomModule> pairs.
const o={},n=(t,e,i)=>{const n=i&&i.moduleId||"custom-style-module-"+a++;Array.isArray(e)||(e=e?[e]:[]),e.forEach(t=>{if(!(t instanceof r.a))throw new Error("An item in styles is not of type CSSResult. Use `unsafeCSS` or `css`.");if(!o[t]){const e=document.createElement("dom-module");e.innerHTML=`<template><style>${t.toString()}</style></template>`;const i="custom-style-module-"+a++;e.register(i),o[t]=i}});const s=document.createElement("dom-module");if(t){const e=window.customElements&&window.customElements.get(t);e&&e.hasOwnProperty("__finalized")&&console.warn(`The custom element definition for "${t}"\n      was finalized before a style module was registered.\n      Make sure to add component specific style modules before\n      importing the corresponding custom element.`),s.setAttribute("theme-for",t)}const l=i&&i.include||[];s.innerHTML=`<template>${l.map(t=>`<style include=${t}></style>`)}\n      ${e.map(t=>`<style include=${o[t]}></style>`)}\n    </template>\n  `,s.register(n)};
/**
 * Registers CSS styles for a component type. Make sure to register the styles before
 * the first instance of a component of the type is attached to DOM.
 *
 * @param {String} themeFor The local/tag name of the component type to register the styles for
 * @param {CSSResult | CSSResult[]} styles The CSS style rules to be registered for the component type
 * matching themeFor and included in the local scope of each component instance
 * @param {Object=} options Additional options
 * @return {void}
 */},
/***/O5j2:
/***/function(t,e,i){"use strict";
/* harmony import */i("CThD"),i("7vYi")
/* harmony import */},
/***/Rjy9:
/***/function(t,e,i){"use strict";
// UNUSED EXPORTS: TimePickerElement
// EXTERNAL MODULE: ./node_modules/@vaadin/vaadin-combo-box/theme/lumo/vaadin-combo-box-light.js?babel-target=es6
i("uNQt"),i("zCHs"),i("XZNo");
// EXTERNAL MODULE: ./node_modules/@vaadin/vaadin-lumo-styles/mixins/field-button.js?babel-target=es6
var r=i("o5Wi");
// CONCATENATED MODULE: ./node_modules/@vaadin/vaadin-time-picker/theme/lumo/vaadin-time-picker-styles.js?babel-target=es6
const a=r.a`<dom-module id="lumo-time-picker" theme-for="vaadin-time-picker"><template><style include="lumo-field-button">[part~=toggle-button]::before{content:var(--lumo-icons-clock)}</style></template></dom-module>`;document.head.appendChild(a.content);
// EXTERNAL MODULE: ./node_modules/@vaadin/vaadin-text-field/theme/lumo/vaadin-text-field.js?babel-target=es6 + 1 modules
i("CThD");
// CONCATENATED MODULE: ./node_modules/@vaadin/vaadin-time-picker/theme/lumo/vaadin-time-picker-text-field-styles.js?babel-target=es6
const o=r.a`<dom-module id="lumo-time-picker-text-field" theme-for="vaadin-time-picker-text-field"><template><style>:host([dir=rtl]) [part=input-field] ::slotted(input:placeholder-shown),:host([dir=rtl]) [part=value]:placeholder-shown,:not(*):placeholder-shown{--_lumo-text-field-overflow-mask-image:none}:host([dir=rtl]) [part=input-field] ::slotted(input),:host([dir=rtl]) [part=value]{--_lumo-text-field-overflow-mask-image:linear-gradient(to left, transparent, #000 1.25em)}</style></template></dom-module>`;document.head.appendChild(o.content);
// EXTERNAL MODULE: ./node_modules/@polymer/polymer/polymer-element.js?babel-target=es6
var n=i("F3iu"),s=i("8u2h"),l=i("OVu0"),d=(i("C/Bj"),i("78gc")),A=i("7vYi");
// EXTERNAL MODULE: ./node_modules/@vaadin/vaadin-themable-mixin/vaadin-themable-mixin.js?babel-target=es6
// CONCATENATED MODULE: ./node_modules/@vaadin/vaadin-time-picker/src/vaadin-time-picker-text-field.js?babel-target=es6
/**
@license
Copyright (c) 2018 Vaadin Ltd.
This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
*/
const h=document.createElement("template");h.innerHTML='<dom-module id="vaadin-time-picker-text-field-styles" theme-for="vaadin-time-picker-text-field"><template><style>:host([dir="rtl"]) [part="input-field"] { direction: ltr; } :host([dir="rtl"]) [part="value"]::placeholder { direction: rtl; text-align: left; } :host([dir="rtl"]) [part="input-field"] ::slotted(input)::placeholder { direction: rtl; text-align: left; } :host([dir="rtl"]) [part="value"]:-ms-input-placeholder, :host([dir="rtl"]) [part="input-field"] ::slotted(input):-ms-input-placeholder { direction: rtl; text-align: left; }</style></template></dom-module>',document.head.appendChild(h.content);
/**
  * The text-field element.
  *
  * ### Styling
  *
  * See [`<vaadin-text-field>` documentation](https://github.com/vaadin/vaadin-text-field/blob/master/src/vaadin-text-field.html)
  * for `<vaadin-time-picker-text-field>` parts and available slots (prefix, suffix etc.)
  *
  * See [ThemableMixin – how to apply styles for shadow parts](https://github.com/vaadin/vaadin-themable-mixin/wiki)
  *
  * @extends PolymerElement
  */
class u extends A.a{static get is(){return"vaadin-time-picker-text-field"}}customElements.define(u.is,u);
// EXTERNAL MODULE: ./node_modules/@vaadin/vaadin-control-state-mixin/vaadin-control-state-mixin.js?babel-target=es6
var p=i("6kUO");
// CONCATENATED MODULE: ./node_modules/@vaadin/vaadin-time-picker/src/vaadin-time-picker.js?babel-target=es6
/**
@license
Copyright (c) 2018 Vaadin Ltd.
This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
*/
/**
 * `<vaadin-time-picker>` is a Web Component providing a time-selection field.
 *
 * ```html
 * <vaadin-time-picker></vaadin-time-picker>
 * ```
 * ```js
 * timePicker.value = '14:30';
 * ```
 *
 * When the selected `value` is changed, a `value-changed` event is triggered.
 *
 * ### Styling
 *
 * The following custom properties are available for styling:
 *
 * Part name | Description
 * ----------------|----------------
 * `toggle-button` | The toggle button
 *
 * See [ThemableMixin – how to apply styles for shadow parts](https://github.com/vaadin/vaadin-themable-mixin/wiki)
 *
 * The following state attributes are available for styling:
 *
 * Attribute    | Description | Part name
 * -------------|-------------|------------
 * `disabled` | Set to a disabled time picker | :host
 * `readonly` | Set to a read only time picker | :host
 * `invalid` | Set when the element is invalid | :host
 * `focused` | Set when the element is focused | :host
 * `focus-ring` | Set when the element is keyboard focused | :host
 *
 * In addition to `<vaadin-time-picker>` itself, the following internal
 * components are themable:
 *
 * - `<vaadin-time-picker-text-field>`, see
 *   [`<vaadin-text-field>` documentation](https://vaadin.com/components/vaadin-text-field/html-api/elements/Vaadin.TextFieldElement)
 *   for the text field parts.
 * - `<vaadin-combo-box-light>`, see
 *   [`<vaadin-combo-box>` documentation](https://vaadin.com/components/vaadin-combo-box/html-api/elements/Vaadin.ComboBoxElement)
 *   for the combo box parts.
 *
 * Note: the `theme` attribute value set on `<vaadin-time-picker>` is
 * propagated to the internal themable components listed above.
 *
 * @extends PolymerElement
 * @mixes ElementMixin
 * @mixes ControlStateMixin
 * @mixes ThemableMixin
 * @demo demo/index.html
 */class c extends(Object(l.a)(Object(p.a)(Object(s.a)(n.a)))){static get template(){return r.a`<style>:host{display:inline-block}:host([hidden]){display:none!important}[part~=toggle-button]{cursor:pointer}.input{width:100%;min-width:0}</style><vaadin-combo-box-light allow-custom-value="" item-label-path="value" filtered-items="[[__dropdownItems]]" disabled="[[disabled]]" readonly="[[readonly]]" auto-open-disabled="[[autoOpenDisabled]]" dir="ltr" theme\$="[[theme]]"><template>[[item.label]]</template><vaadin-time-picker-text-field class="input" name="[[name]]" invalid="[[invalid]]" autocomplete="off" label="[[label]]" required="[[required]]" disabled="[[disabled]]" prevent-invalid-input="[[preventInvalidInput]]" pattern="[[pattern]]" error-message="[[errorMessage]]" autofocus="[[autofocus]]" placeholder="[[placeholder]]" readonly="[[readonly]]" role="application" aria-live="assertive" min\$="[[min]]" max\$="[[max]]" aria-label\$="[[label]]" clear-button-visible="[[clearButtonVisible]]" i18n="[[i18n]]" helper-text="[[helperText]]" theme\$="[[theme]]"><slot name="helper" slot="helper">[[helperText]]</slot><span slot="suffix" part="toggle-button" class="toggle-button" role="button" aria-label\$="[[i18n.selector]]"></span></vaadin-time-picker-text-field></vaadin-combo-box-light>`}static get is(){return"vaadin-time-picker"}static get version(){return"2.4.0"}static get properties(){return{
/**
       * The name of this element.
       */
name:{type:String},
/**
       * The time value for this element.
       *
       * Supported time formats are in ISO 8601:
       * - `hh:mm` (default)
       * - `hh:mm:ss`
       * - `hh:mm:ss.fff`
       * @type {string}
       */
value:{type:String,observer:"__valueChanged",notify:!0,value:""},
/**
       * The label for this element.
       */
label:{type:String,reflectToAttribute:!0},
/**
       * Set to true to mark the input as required.
       * @type {boolean}
       */
required:{type:Boolean,value:!1},
/**
       * Set to true to disable this input.
       * @type {boolean}
       */
disabled:{type:Boolean,value:!1},
/**
       * Set to true to prevent the user from entering invalid input.
       * @attr {boolean} prevent-invalid-input
       */
preventInvalidInput:{type:Boolean},
/**
       * A pattern to validate the `input` with.
       */
pattern:{type:String},
/**
       * The error message to display when the input is invalid.
       * @attr {string} error-message
       */
errorMessage:{type:String},
/**
       * String used for the helper text.
       * @attr {string} helper-text
       */
helperText:{type:String,value:""},
/**
       * A placeholder string in addition to the label.
       * @type {string}
       */
placeholder:{type:String,value:""},
/**
       * Set to true to prevent user picking a date or typing in the input.
       * @type {boolean}
       */
readonly:{type:Boolean,value:!1,reflectToAttribute:!0},
/**
       * Set to true if the value is invalid.
       * @type {boolean}
       */
invalid:{type:Boolean,reflectToAttribute:!0,notify:!0,value:!1},
/**
       * Minimum time allowed.
       *
       * Supported time formats are in ISO 8601:
       * - `hh:mm`
       * - `hh:mm:ss`
       * - `hh:mm:ss.fff`
       * @type {string}
       */
min:{type:String,value:"00:00:00.000"},
/**
       * Maximum time allowed.
       *
       * Supported time formats are in ISO 8601:
       * - `hh:mm`
       * - `hh:mm:ss`
       * - `hh:mm:ss.fff`
       * @type {string}
       */
max:{type:String,value:"23:59:59.999"},
/**
       * Specifies the number of valid intervals in a day used for
       * configuring the items displayed in the selection box.
       *
       * It also configures the precision of the value string. By default
       * the component formats values as `hh:mm` but setting a step value
       * lower than one minute or one second, format resolution changes to
       * `hh:mm:ss` and `hh:mm:ss.fff` respectively.
       *
       * Unit must be set in seconds, and for correctly configuring intervals
       * in the dropdown, it need to evenly divide a day.
       *
       * Note: it is possible to define step that is dividing an hour in inexact
       * fragments (i.e. 5760 seconds which equals 1 hour 36 minutes), but it is
       * not recommended to use it for better UX experience.
       */
step:{type:Number},
/**
       * Set to true to display the clear icon which clears the input.
       * @attr {boolean} clear-button-visible
       * @type {boolean}
       */
clearButtonVisible:{type:Boolean,value:!1},
/**
       * Set true to prevent the overlay from opening automatically.
       * @attr {boolean} auto-open-disabled
       */
autoOpenDisabled:Boolean,
/** @private */
__dropdownItems:{type:Array},
/**
       * The object used to localize this component.
       * To change the default localization, replace the entire
       * _i18n_ object or just the property you want to modify.
       *
       * The object has the following JSON structure:
           {
            // A function to format given `Object` as
            // time string. Object is in the format `{ hours: ..., minutes: ..., seconds: ..., milliseconds: ... }`
            formatTime: (time) => {
              // returns a string representation of the given
              // object in `hh` / 'hh:mm' / 'hh:mm:ss' / 'hh:mm:ss.fff' - formats
            },
             // A function to parse the given text to an `Object` in the format
            // `{ hours: ..., minutes: ..., seconds: ..., milliseconds: ... }`.
            // Must properly parse (at least) text
            // formatted by `formatTime`.
            parseTime: text => {
              // Parses a string in object/string that can be formatted by`formatTime`.
            }
             // Translation of the time selector icon button title.
            selector: 'Time selector',
             // Translation of the time selector clear button title.
            clear: 'Clear'
          }
        * @type {!TimePickerI18n}
        */
i18n:{type:Object,value:()=>({formatTime:t=>{if(!t)return;const e=(t=0,e="00")=>(e+t).substr((e+t).length-e.length)// Always display hour and minute;
let i=`${e(t.hours)}:${e(t.minutes)}`;// Adding second and millisecond depends on resolution
return void 0!==t.seconds&&(i+=":"+e(t.seconds)),void 0!==t.milliseconds&&(i+="."+e(t.milliseconds,"000")),i},parseTime:t=>{
// Parsing with RegExp to ensure correct format
const e=new RegExp("^(\\d|[0-1]\\d|2[0-3])(?::(\\d|[0-5]\\d)(?::(\\d|[0-5]\\d)(?:\\.(\\d{1,3}))?)?)?$").exec(t);if(e){
// Allows setting the milliseconds with hundreds and tens precision
if(e[4])for(;e[4].length<3;)e[4]+="0";return{hours:e[1],minutes:e[2],seconds:e[3],milliseconds:e[4]}}},selector:"Time selector",clear:"Clear"})}}}static get observers(){return["__updateDropdownItems(i18n.*, min, max, step)"]}
/** @protected */ready(){super.ready(),// In order to have synchronized invalid property, we need to use the same validate logic.
this.__inputElement.validate=()=>{},// Not using declarative because we receive an event before text-element shadow is ready,
// thus querySelector in textField.focusElement raises an undefined exception on validate
this.__dropdownElement.addEventListener("value-changed",t=>this.__onInputChange(t)),this.__inputElement.addEventListener("keydown",this.__onKeyDown.bind(this)),// Validation listeners
this.__dropdownElement.addEventListener("change",t=>this.validate()),this.__inputElement.addEventListener("blur",t=>this.validate()),this.__dropdownElement.addEventListener("change",t=>{
// `vaadin-combo-box-light` forwards 'change' event from text-field.
// So we need to filter out in order to avoid duplicates.
t.composedPath()[0]!==this.__inputElement&&this.__dispatchChange()})}
/** @private */__validDayDivisor(t){
// valid if undefined, or exact divides a day, or has millisecond resolution
return!t||86400%t==0||t<1&&t%1*1e3%1==0}
/** @private */__onKeyDown(t){if(this.readonly||this.disabled||this.__dropdownItems.length)return;const e=this.__validDayDivisor(this.step)&&this.step||60;d.a.keyboardEventMatchesKeys(t,"down")?this.__onArrowPressWithStep(-e):d.a.keyboardEventMatchesKeys(t,"up")&&this.__onArrowPressWithStep(e)}
/** @private */__onArrowPressWithStep(t){const e=this.__addStep(this.__getMsec(this.__memoValue),t,!0);this.__memoValue=e,this.__inputElement.value=this.i18n.formatTime(this.__validateTime(e)),this.__dispatchChange()}
/** @private */__dispatchChange(){this.dispatchEvent(new CustomEvent("change",{bubbles:!0}))}
/**
   * Returning milliseconds from Object in the format `{ hours: ..., minutes: ..., seconds: ..., milliseconds: ... }`
   * @private
   */__getMsec(t){let e=60*(t&&t.hours||0)*60*1e3;return e+=60*(t&&t.minutes||0)*1e3,e+=1e3*(t&&t.seconds||0),e+=t&&parseInt(t.milliseconds)||0,e}
/**
   * Returning seconds from Object in the format `{ hours: ..., minutes: ..., seconds: ..., milliseconds: ... }`
   * @private
   */__getSec(t){let e=60*(t&&t.hours||0)*60;return e+=60*(t&&t.minutes||0),e+=t&&t.seconds||0,e+=t&&t.milliseconds/1e3||0,e}
/**
   * Returning Object in the format `{ hours: ..., minutes: ..., seconds: ..., milliseconds: ... }`
   * from the result of adding step value in milliseconds to the milliseconds amount.
   * With `precision` parameter rounding the value to the closest step valid interval.
   * @private
   */__addStep(t,e,i){
// If the time is `00:00` and step changes value downwards, it should be considered as `24:00`
0===t&&e<0&&(t=864e5);const r=1e3*e,a=t%r;r<0&&a&&i?t-=a:r>0&&a&&i?t-=a-r:t+=r;var o=Math.floor(t/1e3/60/60);t-=1e3*o*60*60;var n=Math.floor(t/1e3/60);t-=1e3*n*60;var s=Math.floor(t/1e3);return{hours:o<24?o:0,minutes:n,seconds:s,milliseconds:t-=1e3*s}}
/** @private */__updateDropdownItems(t,e,i,r){const a=this.__validateTime(this.__parseISO(e)),o=this.__getSec(a),n=this.__validateTime(this.__parseISO(i)),s=this.__getSec(n);if(this.__adjustValue(o,s,a,n),this.__dropdownItems=this.__generateDropdownList(o,s,r),r!==this.__oldStep){this.__oldStep=r;const t=this.__validateTime(this.__parseISO(this.value));this.__updateValue(t)}this.value&&(this.__dropdownElement.value=this.i18n.formatTime(this.i18n.parseTime(this.value)))}
/** @private */__generateDropdownList(t,e,i){if(i<900||!this.__validDayDivisor(i))return[];const r=[];// Default step in overlay items is 1 hour
let a=-(i=i||3600)+t;for(;a+i>=t&&a+i<=e;){const t=this.__validateTime(this.__addStep(1e3*a,i));a+=i;const e=this.i18n.formatTime(t);r.push({label:e,value:e})}return r}
/** @private */__adjustValue(t,e,i,r){
// Do not change the value if it is empty
if(!this.__memoValue)return;const a=this.__getSec(this.__memoValue);a<t?this.__updateValue(i):a>e&&this.__updateValue(r)}
/** @private */__valueChanged(t,e){const i=this.__memoValue=this.__parseISO(t),r=this.__formatISO(i)||"";""===this.value||null===this.value||i?this.value!==r?this.value=r:this.__updateInputValue(i):this.value=e}
/** @private */__onInputChange(t){const e=this.i18n.parseTime(this.__dropdownElement.value),i=this.i18n.formatTime(e)||"";e?this.__dropdownElement.value!==i?this.__dropdownElement.value=i:this.__updateValue(e):this.value=""}
/** @private */__updateValue(t){const e=this.__formatISO(this.__validateTime(t))||"";this.value=e}
/** @private */__updateInputValue(t){const e=this.i18n.formatTime(this.__validateTime(t))||"";this.__dropdownElement.value=e}
/** @private */__validateTime(t){return t&&(t.hours=parseInt(t.hours),t.minutes=parseInt(t.minutes||0),t.seconds=this.__stepSegment<3?void 0:parseInt(t.seconds||0),t.milliseconds=this.__stepSegment<4?void 0:parseInt(t.milliseconds||0)),t}
/** @private */get __stepSegment(){return this.step%3600==0?1:this.step%60!=0&&this.step?this.step%1==0?3:this.step<1?4:void 0:2}
/** @private */__formatISO(t){
// The default i18n formatter implementation is ISO 8601 compliant
return c.properties.i18n.value().formatTime(t)}
/** @private */__parseISO(t){
// The default i18n parser implementation is ISO 8601 compliant
return c.properties.i18n.value().parseTime(t)}
/** @protected */_getInputElement(){return this.shadowRoot.querySelector("vaadin-time-picker-text-field")}
/** @private */get __inputElement(){return this.__memoInput||(this.__memoInput=this._getInputElement())}
/** @private */get __dropdownElement(){return this.__memoDropdown||(this.__memoDropdown=this.shadowRoot.querySelector("vaadin-combo-box-light"))}
/**
   * Focusable element used by vaadin-control-state-mixin
   * @return {!HTMLElement}
   * @protected
   */get focusElement(){return this.__inputElement}
/**
   * Returns true if `value` is valid, and sets the `invalid` flag appropriately.
   *
   * @return {boolean} True if the value is valid and sets the `invalid` flag appropriately
   */validate(){return!(this.invalid=!this.checkValidity())}
/**
   * Returns true if `time` satisfies the `min` and `max` constraints (if any).
   *
   * @param {!TimePickerTime} time Value to check against constraints
   * @return {boolean} True if `time` satisfies the constraints
   * @protected
   */_timeAllowed(t){const e=this.i18n.parseTime(this.min),i=this.i18n.parseTime(this.max);return(!this.__getMsec(e)||this.__getMsec(t)>=this.__getMsec(e))&&(!this.__getMsec(i)||this.__getMsec(t)<=this.__getMsec(i))}
/**
   * Returns true if the current input value satisfies all constraints (if any)
   *
   * You can override the `checkValidity` method for custom validations.
   *
   * @return {boolean} True if the value is valid
   */checkValidity(){return!(!this.__inputElement.focusElement.checkValidity()||this.value&&!this._timeAllowed(this.i18n.parseTime(this.value))||this.__dropdownElement.value&&!this.i18n.parseTime(this.__dropdownElement.value))}}customElements.define(c.is,c)},
/***/VBvb:
/***/function(t,e,i){"use strict";
/* harmony import */i("XgHN"),i("+qjT")
/* harmony import */},
/***/WIAz:
/***/function(t,e,i){"use strict";
// UNUSED EXPORTS: TextAreaElement
// EXTERNAL MODULE: ./node_modules/@vaadin/vaadin-lumo-styles/color.js?babel-target=es6
i("h/KH"),i("70OO"),i("7L45");
// EXTERNAL MODULE: ./node_modules/@vaadin/vaadin-lumo-styles/sizing.js?babel-target=es6
var r=i("o5Wi");
// CONCATENATED MODULE: ./node_modules/@vaadin/vaadin-text-field/theme/lumo/vaadin-text-area-styles.js?babel-target=es6
const a=r.a`<dom-module id="lumo-text-area" theme-for="vaadin-text-area"><template><style include="lumo-text-field">[part=input-field],[part=input-field] ::slotted(textarea){padding-top:calc((var(--lumo-text-field-size) - 1em * var(--lumo-line-height-s))/ 2);padding-bottom:calc((var(--lumo-text-field-size) - 1em * var(--lumo-line-height-s))/ 2);height:auto;box-sizing:border-box;transition:background-color .1s;line-height:var(--lumo-line-height-s)}:host(:not([readonly])) [part=input-field]::after{display:none}:host([readonly]) [part=input-field]{border:1px dashed var(--lumo-contrast-30pct)}:host([readonly]) [part=input-field]::after{border:none}:host(:hover:not([readonly]):not([focused]):not([invalid])) [part=input-field]{background-color:var(--lumo-contrast-20pct)}@media (pointer:coarse){:host(:hover:not([readonly]):not([focused]):not([invalid])) [part=input-field]{background-color:var(--lumo-contrast-10pct)}:host(:active:not([readonly]):not([focused])) [part=input-field]{background-color:var(--lumo-contrast-20pct)}}[part=input-field] ::slotted(textarea),[part=value]{line-height:inherit;--_lumo-text-field-overflow-mask-image:none}[part=input-field] ::slotted(iron-icon){margin-top:calc((var(--lumo-icon-size-m) - 1em * var(--lumo-line-height-s))/ -2)}[part=input-field] ::slotted(textarea),[part=input-field] [part=value]{white-space:pre-wrap;align-self:stretch}</style></template></dom-module>`;document.head.appendChild(a.content);
// EXTERNAL MODULE: ./node_modules/@vaadin/vaadin-text-field/theme/lumo/vaadin-text-field.js?babel-target=es6 + 1 modules
i("CThD");
// EXTERNAL MODULE: ./node_modules/@polymer/polymer/polymer-element.js?babel-target=es6
var o=i("F3iu"),n=i("wZOt"),s=i("6kUO"),l=i("8u2h"),d=i("OVu0");
// CONCATENATED MODULE: ./node_modules/@vaadin/vaadin-text-field/src/vaadin-text-area.js?babel-target=es6
/**
@license
Copyright (c) 2017 Vaadin Ltd.
This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
*/
/**
 * `<vaadin-text-area>` is a Web Component for text area control in forms.
 *
 * ```html
 * <vaadin-text-area label="Add description">
 * </vaadin-text-area>
 * ```
 *
 * ### Prefixes and suffixes
 *
 * These are child elements of a `<vaadin-text-area>` that are displayed
 * inline with the input, before or after.
 * In order for an element to be considered as a prefix, it must have the slot
 * attribute set to `prefix` (and similarly for `suffix`).
 *
 * ```html
 * <vaadin-text-area label="Add description">
 *   <div slot="prefix">Details:</div>
 *   <div slot="suffix">The end!</div>
 * </vaadin-text-area>
 * ```
 *
 * ### Styling
 *
 * The following shadow DOM parts are available for styling:
 *
 * Part name | Description
 * ----------------|----------------
 * `label` | The label element
 * `input-field` | The element that wraps prefix, value and suffix
 * `value` | The text value element inside the `input-field` element
 * `error-message` | The error message element
 *
 * The following state attributes are available for styling:
 *
 * Attribute    | Description | Part name
 * -------------|-------------|------------
 * `disabled` | Set to a disabled text field | :host
 * `has-value` | Set when the element has a value | :host
 * `has-label` | Set when the element has a label | :host
 * `has-helper` | Set when the element has helper text | :host
 * `has-error-message` | Set when the element has an error message | :host
 * `invalid` | Set when the element is invalid | :host
 * `focused` | Set when the element is focused | :host
 * `focus-ring` | Set when the element is keyboard focused | :host
 * `readonly` | Set to a readonly text field | :host
 *
 * See [ThemableMixin – how to apply styles for shadow parts](https://github.com/vaadin/vaadin-themable-mixin/wiki)
 *
 * @extends PolymerElement
 * @mixes TextFieldMixin
 * @mixes ControlStateMixin
 * @mixes ElementMixin
 * @mixes ThemableMixin
 * @demo demo/index.html
 */
class A extends(Object(d.a)(Object(n.a)(Object(s.a)(Object(l.a)(o.a))))){static get template(){return r.a`<style include="vaadin-text-field-shared-styles">.vaadin-text-area-container{flex:auto;max-height:inherit;min-height:inherit}[part=error-message],[part=helper-text],[part=label]{flex:none}[part=input-field]{overflow:auto;-webkit-overflow-scrolling:touch}[part=value]{resize:none}[part=input-field] ::slotted(*),[part=value]{align-self:flex-start}@keyframes vaadin-text-area-appear{to{opacity:1}}:host{animation:1ms vaadin-text-area-appear}:host([disabled]) [part=value]{user-select:none}</style><div class="vaadin-text-area-container"><label part="label" on-click="focus" id="[[_labelId]]">[[label]]</label><div part="input-field" id="[[_inputId]]" on-scroll="__scrollPositionUpdated"><slot name="prefix"></slot><slot name="textarea"><textarea part="value"></textarea></slot><div part="clear-button" id="clearButton" role="button" aria-label\$="[[i18n.clear]]"></div><slot name="suffix"></slot></div><div part="helper-text" id="[[_helperTextId]]"><slot name="helper">[[helperText]]</slot></div><div part="error-message" id="[[_errorId]]" aria-live="assertive" aria-hidden\$="[[_getErrorMessageAriaHidden(invalid, errorMessage, _errorId)]]">[[errorMessage]]</div></div>`}static get is(){return"vaadin-text-area"}static get version(){return"2.9.1"}static get properties(){return{
/**
       * A regular expression that the value is checked against.
       * The pattern must match the entire value, not just some subset.
       */
pattern:{type:String}}}static get observers(){return["_textAreaValueChanged(value)"]}
/** @protected */ready(){super.ready(),this._updateHeight(),this.addEventListener("animationend",this._onAnimationEnd),this._inputField=this.root.querySelector("[part=input-field]"),// Wheel scrolling results in async scroll events. Preventing the wheel
// event, scrolling manually and then synchronously updating the scroll position CSS variable
// allows us to avoid some jumpy behavior that would occur on wheel otherwise.
this._inputField.addEventListener("wheel",t=>{t.preventDefault(),this._inputField.scrollTop+=t.deltaY,this.__scrollPositionUpdated()}),this.__scrollPositionUpdated()}
/** @private */__scrollPositionUpdated(){this.updateStyles({"--_text-area-vertical-scroll-position":this._inputField.scrollTop+"px"})}
/** @private */_onAnimationEnd(t){0===t.animationName.indexOf("vaadin-text-area-appear")&&this._updateHeight()}
/**
   * @return {string}
   * @protected
   */get _slottedTagName(){return"textarea"}
/** @private */_textAreaValueChanged(t){this._updateHeight()}
/** @private */_updateHeight(){const t=this.root.querySelector("[part=input-field]"),e=t.scrollTop,i=this.inputElement,r=this.value?this.value.length:0;if(this._oldValueLength>=r){const e=getComputedStyle(t).height,r=getComputedStyle(i).width;// Temporarily fix the height of the wrapping input field container to prevent changing the browsers scroll
// position while resetting the textareas height. If the textarea had a large height, then removing its height
// will reset its height to the default of two rows. That might reduce the height of the page, and the
// browser might adjust the scroll position before we can restore the measured height of the textarea.
t.style.display="block",t.style.height=e,// Fix the input element width so its scroll height isn't affected by host's disappearing scrollbars
i.style.maxWidth=r,// Clear the height of the textarea to allow measuring a reduced scroll height
i.style.height="auto"}this._oldValueLength=r;const a=i.scrollHeight;a>i.clientHeight&&(i.style.height=a+"px"),// Restore
i.style.removeProperty("max-width"),t.style.removeProperty("display"),t.style.removeProperty("height"),t.scrollTop=e,this._dispatchIronResizeEventIfNeeded("InputHeight",a)}
/**
   * Returns true if the current textarea value satisfies all constraints (if any).
   * @return {boolean}
   */checkValidity(){if(!super.checkValidity())return!1;// Native <textarea> does not support pattern attribute, so we have a custom logic
// according to WHATWG spec for <input>, with tests inspired by web-platform-tests
// https://html.spec.whatwg.org/multipage/input.html#the-pattern-attribute
if(!this.pattern||!this.inputElement.value)
// Mark as valid if there is no pattern, or the value is empty
return!0;try{const t=this.inputElement.value.match(this.pattern);return!!t&&t[0]===t.input}catch(t){
// If the pattern can not be compiled, then report as valid
return!0}}
/**
   * Fired when the text-area height changes.
   *
   * @event iron-resize
   */}customElements.define(A.is,A)},
/***/XgHN:
/***/function(t,e,i){"use strict";
// EXTERNAL MODULE: ./node_modules/@vaadin/vaadin-lumo-styles/color.js?babel-target=es6
i("h/KH"),i("70OO"),i("y+0W"),i("7L45");
// EXTERNAL MODULE: ./node_modules/@vaadin/vaadin-lumo-styles/sizing.js?babel-target=es6
// CONCATENATED MODULE: ./node_modules/@vaadin/vaadin-tabs/theme/lumo/vaadin-tab-styles.js?babel-target=es6
const r=i("o5Wi").a`<dom-module id="lumo-tab" theme-for="vaadin-tab"><template><style>:host{box-sizing:border-box;padding:.5rem .75rem;font-family:var(--lumo-font-family);font-size:var(--lumo-font-size-m);line-height:var(--lumo-line-height-xs);font-weight:500;opacity:1;color:var(--lumo-contrast-60pct);transition:.15s color,.2s transform;flex-shrink:0;display:flex;align-items:center;position:relative;cursor:pointer;transform-origin:50% 100%;outline:0;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;overflow:hidden;min-width:var(--lumo-size-m);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}:host(:not([orientation=vertical])){text-align:center}:host([orientation=vertical]){transform-origin:0 50%;padding:.25rem 1rem;min-height:var(--lumo-size-m);min-width:0}:host(:hover),:host([focus-ring]){color:var(--lumo-body-text-color)}:host([selected]){color:var(--lumo-primary-text-color);transition:.6s color}:host([active]:not([selected])){color:var(--lumo-primary-text-color);transition-duration:.1s}:host::after,:host::before{content:"";position:absolute;display:var(--_lumo-tab-marker-display,block);bottom:0;left:50%;width:var(--lumo-size-s);height:2px;background-color:var(--lumo-contrast-60pct);border-radius:var(--lumo-border-radius) var(--lumo-border-radius) 0 0;transform:translateX(-50%) scale(0);transform-origin:50% 100%;transition:.14s transform cubic-bezier(.12,.32,.54,1);will-change:transform}:host([selected])::after,:host([selected])::before{background-color:var(--lumo-primary-color)}:host([orientation=vertical])::after,:host([orientation=vertical])::before{left:0;bottom:50%;transform:translateY(50%) scale(0);width:2px;height:var(--lumo-size-xs);border-radius:0 var(--lumo-border-radius) var(--lumo-border-radius) 0;transform-origin:100% 50%}:host::after{box-shadow:0 0 0 4px var(--lumo-primary-color);opacity:.15;transition:.15s 20ms transform,.8s .17s opacity}:host([selected])::after,:host([selected])::before{transform:translateX(-50%) scale(1);transition-timing-function:cubic-bezier(.12,.32,.54,1.5)}:host([orientation=vertical][selected])::after,:host([orientation=vertical][selected])::before{transform:translateY(50%) scale(1)}:host([selected]:not([active]))::after{opacity:0}:host(:not([orientation=vertical])) ::slotted(a[href]){justify-content:center}:host ::slotted(a){display:flex;width:100%;align-items:center;height:100%;margin:-.5rem -.75rem;padding:.5rem .75rem;outline:0;text-decoration:none!important;color:inherit!important}:host ::slotted(iron-icon){margin:0 4px;width:var(--lumo-icon-size-m);height:var(--lumo-icon-size-m)}:host ::slotted(iron-icon[icon^="vaadin:"]){padding:.25rem;box-sizing:border-box!important}:host(:not([dir=rtl])) ::slotted(iron-icon:first-child){margin-left:0}:host(:not([dir=rtl])) ::slotted(iron-icon:last-child){margin-right:0}:host([theme~=icon-on-top]){display:flex;flex-direction:column;align-items:center;justify-content:space-around;text-align:center;padding-bottom:.5rem;padding-top:.25rem}:host([theme~=icon-on-top]) ::slotted(a){flex-direction:column;align-items:center;margin-top:-.25rem;padding-top:.25rem}:host([theme~=icon-on-top]) ::slotted(iron-icon){margin:0}:host([disabled]){pointer-events:none;opacity:1;color:var(--lumo-disabled-text-color)}:host([focus-ring]){box-shadow:inset 0 0 0 2px var(--lumo-primary-color-50pct);border-radius:var(--lumo-border-radius)}:host([dir=rtl])::after,:host([dir=rtl])::before{left:auto;right:50%;transform:translateX(50%) scale(0)}:host([dir=rtl][selected]:not([orientation=vertical]))::after,:host([dir=rtl][selected]:not([orientation=vertical]))::before{transform:translateX(50%) scale(1)}:host([dir=rtl]) ::slotted(iron-icon:first-child){margin-right:0}:host([dir=rtl]) ::slotted(iron-icon:last-child){margin-left:0}:host([orientation=vertical][dir=rtl]){transform-origin:100% 50%}:host([dir=rtl][orientation=vertical])::after,:host([dir=rtl][orientation=vertical])::before{left:auto;right:0;border-radius:var(--lumo-border-radius) 0 0 var(--lumo-border-radius);transform-origin:0 50%}</style></template></dom-module>`;document.head.appendChild(r.content);
// EXTERNAL MODULE: ./node_modules/@vaadin/vaadin-tabs/src/vaadin-tab.js?babel-target=es6
i("+qjT");
// CONCATENATED MODULE: ./node_modules/@vaadin/vaadin-tabs/theme/lumo/vaadin-tab.js?babel-target=es6
/***/},
/***/bSoT:
/***/function(t,e,i){"use strict";
// EXPORTS
i.d(e,"a",(function(){/* reexport */return o}));
// EXTERNAL MODULE: ./node_modules/@vaadin/vaadin-development-mode-detector/vaadin-development-mode-detector.js?babel-target=es6
var r=i("EQ8s");
// CONCATENATED MODULE: ./node_modules/@vaadin/vaadin-usage-statistics/vaadin-usage-statistics-collect.js?babel-target=es6
/* This file is autogenerated from src/vaadin-usage-statistics.tpl.html */
/*

This script gathers usage statistics from the application running in development mode.

Statistics gathering is automatically disabled and excluded from production builds.

For details and to opt-out, see https://github.com/vaadin/vaadin-usage-statistics.

*/
/*
  FIXME(polymer-modulizer): the above comments were extracted
  from HTML and may be out of place here. Review them and
  then delete this comment!
*/function a(){
/** vaadin-dev-mode:start
  (function () {
  'use strict';
  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
  } : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };
  var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
  };
  var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
   return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
  }();
  var getPolymerVersion = function getPolymerVersion() {
  return window.Polymer && window.Polymer.version;
  };
  var StatisticsGatherer = function () {
  function StatisticsGatherer(logger) {
    classCallCheck(this, StatisticsGatherer);
     this.now = new Date().getTime();
    this.logger = logger;
  }
   createClass(StatisticsGatherer, [{
    key: 'frameworkVersionDetectors',
    value: function frameworkVersionDetectors() {
      return {
        'Flow': function Flow() {
          if (window.Vaadin && window.Vaadin.Flow && window.Vaadin.Flow.clients) {
            var flowVersions = Object.keys(window.Vaadin.Flow.clients).map(function (key) {
              return window.Vaadin.Flow.clients[key];
            }).filter(function (client) {
              return client.getVersionInfo;
            }).map(function (client) {
              return client.getVersionInfo().flow;
            });
            if (flowVersions.length > 0) {
              return flowVersions[0];
            }
          }
        },
        'Vaadin Framework': function VaadinFramework() {
          if (window.vaadin && window.vaadin.clients) {
            var frameworkVersions = Object.values(window.vaadin.clients).filter(function (client) {
              return client.getVersionInfo;
            }).map(function (client) {
              return client.getVersionInfo().vaadinVersion;
            });
            if (frameworkVersions.length > 0) {
              return frameworkVersions[0];
            }
          }
        },
        'AngularJs': function AngularJs() {
          if (window.angular && window.angular.version && window.angular.version) {
            return window.angular.version.full;
          }
        },
        'Angular': function Angular() {
          if (window.ng) {
            var tags = document.querySelectorAll("[ng-version]");
            if (tags.length > 0) {
              return tags[0].getAttribute("ng-version");
            }
            return "Unknown";
          }
        },
        'Backbone.js': function BackboneJs() {
          if (window.Backbone) {
            return window.Backbone.VERSION;
          }
        },
        'React': function React() {
          var reactSelector = '[data-reactroot], [data-reactid]';
          if (!!document.querySelector(reactSelector)) {
            // React does not publish the version by default
            return "unknown";
          }
        },
        'Ember': function Ember() {
          if (window.Em && window.Em.VERSION) {
            return window.Em.VERSION;
          } else if (window.Ember && window.Ember.VERSION) {
            return window.Ember.VERSION;
          }
        },
        'jQuery': function (_jQuery) {
          function jQuery() {
            return _jQuery.apply(this, arguments);
          }
           jQuery.toString = function () {
            return _jQuery.toString();
          };
           return jQuery;
        }(function () {
          if (typeof jQuery === 'function' && jQuery.prototype.jquery !== undefined) {
            return jQuery.prototype.jquery;
          }
        }),
        'Polymer': function Polymer() {
          var version = getPolymerVersion();
          if (version) {
            return version;
          }
        },
        'LitElement': function LitElement() {
          var version = window.litElementVersions && window.litElementVersions[0];
          if (version) {
            return version;
          }
        },
        'LitHtml': function LitHtml() {
          var version = window.litHtmlVersions && window.litHtmlVersions[0];
          if (version) {
            return version;
          }
        },
        'Vue.js': function VueJs() {
          if (window.Vue) {
            return window.Vue.version;
          }
        }
      };
    }
  }, {
    key: 'getUsedVaadinElements',
    value: function getUsedVaadinElements(elements) {
      var version = getPolymerVersion();
      var elementClasses = void 0;
      // NOTE: In case you edit the code here, YOU MUST UPDATE any statistics reporting code in Flow.
      // Check all locations calling the method getEntries() in
      // https://github.com/vaadin/flow/blob/master/flow-server/src/main/java/com/vaadin/flow/internal/UsageStatistics.java#L106
      // Currently it is only used by BootstrapHandler.
      if (version && version.indexOf('2') === 0) {
        // Polymer 2: components classes are stored in window.Vaadin
        elementClasses = Object.keys(window.Vaadin).map(function (c) {
          return window.Vaadin[c];
        }).filter(function (c) {
          return c.is;
        });
      } else {
        // Polymer 3: components classes are stored in window.Vaadin.registrations
        elementClasses = window.Vaadin.registrations || [];
      }
      elementClasses.forEach(function (klass) {
        var version = klass.version ? klass.version : "0.0.0";
        elements[klass.is] = { version: version };
      });
    }
  }, {
    key: 'getUsedVaadinThemes',
    value: function getUsedVaadinThemes(themes) {
      ['Lumo', 'Material'].forEach(function (themeName) {
        var theme;
        var version = getPolymerVersion();
        if (version && version.indexOf('2') === 0) {
          // Polymer 2: themes are stored in window.Vaadin
          theme = window.Vaadin[themeName];
        } else {
          // Polymer 3: themes are stored in custom element registry
          theme = customElements.get('vaadin-' + themeName.toLowerCase() + '-styles');
        }
        if (theme && theme.version) {
          themes[themeName] = { version: theme.version };
        }
      });
    }
  }, {
    key: 'getFrameworks',
    value: function getFrameworks(frameworks) {
      var detectors = this.frameworkVersionDetectors();
      Object.keys(detectors).forEach(function (framework) {
        var detector = detectors[framework];
        try {
          var version = detector();
          if (version) {
            frameworks[framework] = { version: version };
          }
        } catch (e) {}
      });
    }
  }, {
    key: 'gather',
    value: function gather(storage) {
      var storedStats = storage.read();
      var gatheredStats = {};
      var types = ["elements", "frameworks", "themes"];
       types.forEach(function (type) {
        gatheredStats[type] = {};
        if (!storedStats[type]) {
          storedStats[type] = {};
        }
      });
       var previousStats = JSON.stringify(storedStats);
       this.getUsedVaadinElements(gatheredStats.elements);
      this.getFrameworks(gatheredStats.frameworks);
      this.getUsedVaadinThemes(gatheredStats.themes);
       var now = this.now;
      types.forEach(function (type) {
        var keys = Object.keys(gatheredStats[type]);
        keys.forEach(function (key) {
          if (!storedStats[type][key] || _typeof(storedStats[type][key]) != _typeof({})) {
            storedStats[type][key] = { firstUsed: now };
          }
          // Discards any previously logged version number
          storedStats[type][key].version = gatheredStats[type][key].version;
          storedStats[type][key].lastUsed = now;
        });
      });
       var newStats = JSON.stringify(storedStats);
      storage.write(newStats);
      if (newStats != previousStats && Object.keys(storedStats).length > 0) {
        this.logger.debug("New stats: " + newStats);
      }
    }
  }]);
  return StatisticsGatherer;
  }();
  var StatisticsStorage = function () {
  function StatisticsStorage(key) {
    classCallCheck(this, StatisticsStorage);
     this.key = key;
  }
   createClass(StatisticsStorage, [{
    key: 'read',
    value: function read() {
      var localStorageStatsString = localStorage.getItem(this.key);
      try {
        return JSON.parse(localStorageStatsString ? localStorageStatsString : '{}');
      } catch (e) {
        return {};
      }
    }
  }, {
    key: 'write',
    value: function write(data) {
      localStorage.setItem(this.key, data);
    }
  }, {
    key: 'clear',
    value: function clear() {
      localStorage.removeItem(this.key);
    }
  }, {
    key: 'isEmpty',
    value: function isEmpty() {
      var storedStats = this.read();
      var empty = true;
      Object.keys(storedStats).forEach(function (key) {
        if (Object.keys(storedStats[key]).length > 0) {
          empty = false;
        }
      });
       return empty;
    }
  }]);
  return StatisticsStorage;
  }();
  var StatisticsSender = function () {
  function StatisticsSender(url, logger) {
    classCallCheck(this, StatisticsSender);
     this.url = url;
    this.logger = logger;
  }
   createClass(StatisticsSender, [{
    key: 'send',
    value: function send(data, errorHandler) {
      var logger = this.logger;
       if (navigator.onLine === false) {
        logger.debug("Offline, can't send");
        errorHandler();
        return;
      }
      logger.debug("Sending data to " + this.url);
       var req = new XMLHttpRequest();
      req.withCredentials = true;
      req.addEventListener("load", function () {
        // Stats sent, nothing more to do
        logger.debug("Response: " + req.responseText);
      });
      req.addEventListener("error", function () {
        logger.debug("Send failed");
        errorHandler();
      });
      req.addEventListener("abort", function () {
        logger.debug("Send aborted");
        errorHandler();
      });
      req.open("POST", this.url);
      req.setRequestHeader("Content-Type", "application/json");
      req.send(data);
    }
  }]);
  return StatisticsSender;
  }();
  var StatisticsLogger = function () {
  function StatisticsLogger(id) {
    classCallCheck(this, StatisticsLogger);
     this.id = id;
  }
   createClass(StatisticsLogger, [{
    key: '_isDebug',
    value: function _isDebug() {
      return localStorage.getItem("vaadin." + this.id + ".debug");
    }
  }, {
    key: 'debug',
    value: function debug(msg) {
      if (this._isDebug()) {
        console.info(this.id + ": " + msg);
      }
    }
  }]);
  return StatisticsLogger;
  }();
  var UsageStatistics = function () {
  function UsageStatistics() {
    classCallCheck(this, UsageStatistics);
     this.now = new Date();
    this.timeNow = this.now.getTime();
    this.gatherDelay = 10; // Delay between loading this file and gathering stats
    this.initialDelay = 24 * 60 * 60;
     this.logger = new StatisticsLogger("statistics");
    this.storage = new StatisticsStorage("vaadin.statistics.basket");
    this.gatherer = new StatisticsGatherer(this.logger);
    this.sender = new StatisticsSender("https://tools.vaadin.com/usage-stats/submit", this.logger);
  }
   createClass(UsageStatistics, [{
    key: 'maybeGatherAndSend',
    value: function maybeGatherAndSend() {
      var _this = this;
       if (localStorage.getItem(UsageStatistics.optOutKey)) {
        return;
      }
      this.gatherer.gather(this.storage);
      setTimeout(function () {
        _this.maybeSend();
      }, this.gatherDelay * 1000);
    }
  }, {
    key: 'lottery',
    value: function lottery() {
      return true;
    }
  }, {
    key: 'currentMonth',
    value: function currentMonth() {
      return this.now.getYear() * 12 + this.now.getMonth();
    }
  }, {
    key: 'maybeSend',
    value: function maybeSend() {
      var firstUse = Number(localStorage.getItem(UsageStatistics.firstUseKey));
      var monthProcessed = Number(localStorage.getItem(UsageStatistics.monthProcessedKey));
       if (!firstUse) {
        // Use a grace period to avoid interfering with tests, incognito mode etc
        firstUse = this.timeNow;
        localStorage.setItem(UsageStatistics.firstUseKey, firstUse);
      }
       if (this.timeNow < firstUse + this.initialDelay * 1000) {
        this.logger.debug("No statistics will be sent until the initial delay of " + this.initialDelay + "s has passed");
        return;
      }
      if (this.currentMonth() <= monthProcessed) {
        this.logger.debug("This month has already been processed");
        return;
      }
      localStorage.setItem(UsageStatistics.monthProcessedKey, this.currentMonth());
      // Use random sampling
      if (this.lottery()) {
        this.logger.debug("Congratulations, we have a winner!");
      } else {
        this.logger.debug("Sorry, no stats from you this time");
        return;
      }
       this.send();
    }
  }, {
    key: 'send',
    value: function send() {
      // Ensure we have the latest data
      this.gatherer.gather(this.storage);
       // Read, send and clean up
      var data = this.storage.read();
      data["firstUse"] = Number(localStorage.getItem(UsageStatistics.firstUseKey));
      data["usageStatisticsVersion"] = UsageStatistics.version;
      var info = 'This request contains usage statistics gathered from the application running in development mode. \n\nStatistics gathering is automatically disabled and excluded from production builds.\n\nFor details and to opt-out, see https://github.com/vaadin/vaadin-usage-statistics.\n\n\n\n';
      var self = this;
      this.sender.send(info + JSON.stringify(data), function () {
        // Revert the 'month processed' flag
        localStorage.setItem(UsageStatistics.monthProcessedKey, self.currentMonth() - 1);
      });
    }
  }], [{
    key: 'version',
    get: function get$1() {
      return '2.1.2';
    }
  }, {
    key: 'firstUseKey',
    get: function get$1() {
      return 'vaadin.statistics.firstuse';
    }
  }, {
    key: 'monthProcessedKey',
    get: function get$1() {
      return 'vaadin.statistics.monthProcessed';
    }
  }, {
    key: 'optOutKey',
    get: function get$1() {
      return 'vaadin.statistics.optout';
    }
  }]);
  return UsageStatistics;
  }();
  try {
  window.Vaadin = window.Vaadin || {};
  window.Vaadin.usageStatsChecker = window.Vaadin.usageStatsChecker || new UsageStatistics();
  window.Vaadin.usageStatsChecker.maybeGatherAndSend();
  } catch (e) {
  // Intentionally ignored as this is not a problem in the app being developed
  }
  }());
   vaadin-dev-mode:end **/}const o=function(){if("function"==typeof r.a)return Object(r.a)(a)};
// CONCATENATED MODULE: ./node_modules/@vaadin/vaadin-usage-statistics/vaadin-usage-statistics.js?babel-target=es6
/***/},
/***/bjSq:
/***/function(t,e,i){"use strict";
/* harmony export (binding) */i.d(e,"a",(function(){return r}));
/**
 * @polymerMixin
 */
const r=t=>class extends t{static get properties(){return{
/**
       * Helper property with theme attribute value facilitating propagation
       * in shadow DOM.
       *
       * Enables the component implementation to propagate the `theme`
       * attribute value to the subcomponents in Shadow DOM by binding
       * the subcomponent’s "theme" attribute to the `theme` property of
       * the host.
       *
       * **NOTE:** Extending the mixin only provides the property for binding,
       * and does not make the propagation alone.
       *
       * See [Theme Attribute and Subcomponents](https://github.com/vaadin/vaadin-themable-mixin/wiki/5.-Theme-Attribute-and-Subcomponents).
       * page for more information.
       *
       * @protected
       */
theme:{type:String,readOnly:!0}}}
/** @protected */attributeChangedCallback(t,e,i){super.attributeChangedCallback(t,e,i),"theme"===t&&this._setTheme(i)}}
/***/},
/***/hSgB:
/***/function(t,e,i){"use strict";
// UNUSED EXPORTS: NumberFieldElement
// EXTERNAL MODULE: ./node_modules/@vaadin/vaadin-lumo-styles/font-icons.js?babel-target=es6
i("XZNo"),i("70OO"),i("zCHs");
// EXTERNAL MODULE: ./node_modules/@vaadin/vaadin-lumo-styles/sizing.js?babel-target=es6
var r=i("o5Wi");
// CONCATENATED MODULE: ./node_modules/@vaadin/vaadin-text-field/theme/lumo/vaadin-number-field-styles.js?babel-target=es6
const a=r.a`<dom-module id="lumo-number-field" theme-for="vaadin-number-field"><template><style include="lumo-field-button">:host{width:8em}:host([has-controls]:not([theme~=align-right])) [part=value]{text-align:center}[part=decrease-button][disabled],[part=increase-button][disabled]{opacity:.2}:host([has-controls]) [part=input-field]{padding:0}[part=decrease-button],[part=increase-button]{cursor:pointer;font-size:var(--lumo-icon-size-s);width:1.6em;height:1.6em}[part=decrease-button]::before,[part=increase-button]::before{margin-top:.2em}:host([dir=rtl]) [part=input-field] ::slotted(input),:host([dir=rtl]) [part=value]{--_lumo-text-field-overflow-mask-image:linear-gradient(to left, transparent, #000 1.25em)}</style></template></dom-module>`;document.head.appendChild(a.content);
// EXTERNAL MODULE: ./node_modules/@vaadin/vaadin-text-field/theme/lumo/vaadin-text-field.js?babel-target=es6 + 1 modules
i("CThD"),i("F3iu"),i("GgZ1");
// EXTERNAL MODULE: ./node_modules/@polymer/polymer/polymer-element.js?babel-target=es6
var o=i("7vYi"),n=i("O5q1");
// CONCATENATED MODULE: ./node_modules/@vaadin/vaadin-text-field/src/vaadin-number-field.js?babel-target=es6
/**
@license
Copyright (c) 2017 Vaadin Ltd.
This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
*/
const s=r.a`<dom-module id="vaadin-number-field-template"><template><style>:host([readonly]) [part\$=button]{pointer-events:none}[part=decrease-button]::before{content:"−"}[part=increase-button]::before{content:"+"}[part=decrease-button],[part=increase-button]{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}[part=value]::-webkit-inner-spin-button,[part=value]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}[part=value]{-moz-appearance:textfield!important}:host([dir=rtl]) [part=input-field]{direction:ltr}:host([dir=rtl]) [part=value]::placeholder{direction:rtl}:host([dir=rtl]) [part=input-field] ::slotted(input)::placeholder{direction:rtl}:host([dir=rtl]) [part=input-field] ::slotted(input):-ms-input-placeholder,:host([dir=rtl]) [part=value]:-ms-input-placeholder{direction:rtl}:host([dir=rtl]:not([has-controls])) [part=value]::placeholder{text-align:left}:host([dir=rtl]:not([has-controls])) [part=input-field] ::slotted(input)::placeholder{text-align:left}:host([dir=rtl]:not([has-controls])) [part=input-field] ::slotted(input):-ms-input-placeholder,:host([dir=rtl]:not([has-controls])) [part=value]:-ms-input-placeholder{text-align:left}</style><div disabled\$="[[!_allowed(-1, value, min, max, step)]]" part="decrease-button" on-click="_decreaseValue" on-touchend="_decreaseButtonTouchend" hidden\$="[[!hasControls]]"></div><div disabled\$="[[!_allowed(1, value, min, max, step)]]" part="increase-button" on-click="_increaseValue" on-touchend="_increaseButtonTouchend" hidden\$="[[!hasControls]]"></div></template></dom-module>`;let l;
/**
 * `<vaadin-number-field>` is a Web Component for number field control in forms.
 *
 * ```html
 * <vaadin-number-field label="Number">
 * </vaadin-number-field>
 * ```
 * @extends TextFieldElement
 * @demo demo/index.html
 */document.head.appendChild(s.content);class d extends o.a{static get is(){return"vaadin-number-field"}static get version(){return"2.9.1"}static get properties(){return{
/**
       * Set to true to display value increase/decrease controls.
       * @attr {boolean} has-controls
       * @type {boolean}
       */
hasControls:{type:Boolean,value:!1,reflectToAttribute:!0},
/**
       * The minimum value of the field.
       */
min:{type:Number,reflectToAttribute:!0,observer:"_minChanged"},
/**
       * The maximum value of the field.
       */
max:{type:Number,reflectToAttribute:!0,observer:"_maxChanged"},
/**
       * Specifies the allowed number intervals of the field.
       * @type {number}
       */
step:{type:Number,value:1,observer:"_stepChanged"}}}
/** @protected */ready(){super.ready(),this.__previousValidInput=this.value||"",this.inputElement.type="number",this.inputElement.addEventListener("change",this.__onInputChange.bind(this))}
/** @private */_decreaseButtonTouchend(t){
// Cancel the following click and focus events
t.preventDefault(),this._decreaseValue()}
/** @private */_increaseButtonTouchend(t){
// Cancel the following click and focus events
t.preventDefault(),this._increaseValue()}static get template(){if(!l){
// Clone the superclass template
l=super.template.cloneNode(!0);// Retrieve this element's dom-module template
const t=n.a.import(this.is+"-template","template"),e=t.content.querySelector('[part="decrease-button"]'),i=t.content.querySelector('[part="increase-button"]'),r=t.content.querySelector("style"),a=l.content.querySelector('[part="input-field"]'),o=l.content.querySelector('[name="prefix"]');a.insertBefore(e,o),a.appendChild(i),l.content.appendChild(r)}return l}
/** @protected */_createConstraintsObserver(){
// NOTE: do not call "super" but instead override the method to add extra arguments
this._createMethodObserver("_constraintsChanged(required, minlength, maxlength, pattern, min, max, step)")}
/** @private */_constraintsChanged(t,e,i,r,a,o,n){if(!this.invalid)return;const s=t=>!t&&0!==t;s(a)&&s(o)?super._constraintsChanged(t,e,i,r):this.validate()}
/** @private */_decreaseValue(){this._incrementValue(-1)}
/** @private */_increaseValue(){this._incrementValue(1)}
/** @private */_incrementValue(t){if(this.disabled||this.readonly)return;let e=parseFloat(this.value);this.value?e<this.min?(t=0,e=this.min):e>this.max&&(t=0,e=this.max):0==this.min&&t<0||0==this.max&&t>0||0==this.max&&0==this.min?(t=0,e=0):(null==this.max||this.max>=0)&&(null==this.min||this.min<=0)?e=0:this.min>0?(e=this.min,this.max<0&&t<0&&(e=this.max),t=0):this.max<0&&(e=this.max,t<0?t=0:
// FIXME(yuriy): find a proper solution to make correct step back
this._getIncrement(1,e-this.step)>this.max?e-=2*this.step:e-=this.step);const i=this._getIncrement(t,e);this.value&&0!=t&&!this._incrementIsInsideTheLimits(t,e)||this._setValue(i)}
/** @private */_setValue(t){this.value=this.inputElement.value=String(parseFloat(t)),this.dispatchEvent(new CustomEvent("change",{bubbles:!0}))}
/** @private */_getIncrement(t,e){let i=this.step||1,r=this.min||0;// To avoid problems with decimal math, multiplying to operate with integers.
const a=Math.max(this._getMultiplier(e),this._getMultiplier(i),this._getMultiplier(r));i*=a,r*=a;const o=((e=Math.round(e*a))-r)%i;return t>0?(e-o+i)/a:t<0?(e-(o||i))/a:e/a}
/** @private */_getDecimalCount(t){const e=String(t),i=e.indexOf(".");return-1===i?1:e.length-i-1}
/** @private */_getMultiplier(t){if(!isNaN(t))return Math.pow(10,this._getDecimalCount(t))}
/** @private */_incrementIsInsideTheLimits(t,e){return t<0?null==this.min||this._getIncrement(t,e)>=this.min:t>0?null==this.max||this._getIncrement(t,e)<=this.max:this._getIncrement(t,e)<=this.max&&this._getIncrement(t,e)>=this.min}
/** @private */_allowed(t){const e=t*(this.step||1),i=parseFloat(this.value);return!this.value||!this.disabled&&this._incrementIsInsideTheLimits(e,i)}
/**
   * @param {number} newVal
   * @param {number | undefined} oldVal
   * @protected
   */_stepChanged(t,e){
// Avoid using initial value in validation
this.__validateByStep=this.__stepChangedCalled||null!==this.getAttribute("step"),this.inputElement.step=this.__validateByStep?t:"any",this.__stepChangedCalled=!0,this.setAttribute("step",t)}
/** @private */_minChanged(t){this.inputElement.min=t}
/** @private */_maxChanged(t){this.inputElement.max=t}
/**
   * @param {unknown} newVal
   * @param {unknown} oldVal
   * @protected
   */_valueChanged(t,e){
// Validate value to be numeric
t&&isNaN(parseFloat(t))?this.value="":"string"!=typeof this.value&&(this.value=String(this.value)),super._valueChanged(this.value,e)}
/**
   * @param {!KeyboardEvent} e
   * @protected
   */_onKeyDown(t){38==t.keyCode?(t.preventDefault(),this._increaseValue()):40==t.keyCode&&(t.preventDefault(),this._decreaseValue()),super._onKeyDown(t)}
/** @private */__onInputChange(){this.validate()}
/**
   * @return {boolean}
   */checkValidity(){
// text-field mixin does not check against `min`, `max` and `step`
return void 0!==this.min||void 0!==this.max||this.__validateByStep?this.inputElement.checkValidity():super.checkValidity()}}window.customElements.define(d.is,d)},
/***/oDC5:
/***/function(t,e,i){"use strict";
// UNUSED EXPORTS: EmailFieldElement
// EXTERNAL MODULE: ./node_modules/@polymer/polymer/lib/utils/html-tag.js?babel-target=es6
var r=i("o5Wi");
// CONCATENATED MODULE: ./node_modules/@vaadin/vaadin-text-field/theme/lumo/vaadin-email-field-styles.js?babel-target=es6
const a=r.a`<dom-module id="lumo-email-field" theme-for="vaadin-email-field"><template><style>:host([dir=rtl]) [part=input-field] ::slotted(input:placeholder-shown),:host([dir=rtl]) [part=value]:placeholder-shown,:not(*):placeholder-shown{--_lumo-text-field-overflow-mask-image:none}:host([dir=rtl]) [part=input-field] ::slotted(input),:host([dir=rtl]) [part=value]{--_lumo-text-field-overflow-mask-image:linear-gradient(to left, transparent, #000 1.25em)}</style></template></dom-module>`;document.head.appendChild(a.content);
// EXTERNAL MODULE: ./node_modules/@vaadin/vaadin-text-field/theme/lumo/vaadin-text-field.js?babel-target=es6 + 1 modules
i("CThD"),i("F3iu"),i("GgZ1");
// EXTERNAL MODULE: ./node_modules/@polymer/polymer/polymer-element.js?babel-target=es6
var o=i("7vYi"),n=i("O5q1");
// CONCATENATED MODULE: ./node_modules/@vaadin/vaadin-text-field/src/vaadin-email-field.js?babel-target=es6
/**
@license
Copyright (c) 2018 Vaadin Ltd.
This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
*/
const s=r.a`<dom-module id="vaadin-email-field-template"><template><style>:host([dir=rtl]) [part=input-field]{direction:ltr}:host([dir=rtl]) [part=value]::placeholder{direction:rtl;text-align:left}:host([dir=rtl]) [part=input-field] ::slotted(input)::placeholder{direction:rtl;text-align:left}:host([dir=rtl]) [part=input-field] ::slotted(input):-ms-input-placeholder,:host([dir=rtl]) [part=value]:-ms-input-placeholder{direction:rtl;text-align:left}</style></template></dom-module>`;let l;
/**
 * `<vaadin-email-field>` is a Web Component for email field control in forms.
 *
 * ```html
 * <vaadin-email-field label="Email">
 * </vaadin-email-field>
 * ```
 *
 * ### Styling
 *
 * See vaadin-text-field.html for the styling documentation
 *
 * See [ThemableMixin – how to apply styles for shadow parts](https://github.com/vaadin/vaadin-themable-mixin/wiki)
 *
 * @extends TextFieldElement
 * @demo demo/index.html
 */document.head.appendChild(s.content);class d extends o.a{static get is(){return"vaadin-email-field"}static get version(){return"2.9.1"}static get template(){if(!l){
// Clone the superclass template
l=super.template.cloneNode(!0);// Retrieve this element's dom-module template
const t=n.a.import(this.is+"-template","template").content.querySelector("style");// Add the and styles to the text-field template
l.content.appendChild(t)}return l}
/** @protected */ready(){super.ready(),this.inputElement.type="email",this.inputElement.autocapitalize="off"}
/** @protected */_createConstraintsObserver(){
// NOTE: pattern needs to be set before constraints observer is initialized
this.pattern=this.pattern||"^([a-zA-Z0-9_\\.\\-+])+@[a-zA-Z0-9-.]+\\.[a-zA-Z0-9-]{2,}$",super._createConstraintsObserver()}}customElements.define(d.is,d)},
/***/r7YR:
/***/function(t,e,i){"use strict";
// UNUSED EXPORTS: TabsElement
// EXTERNAL MODULE: ./node_modules/@vaadin/vaadin-tabs/theme/lumo/vaadin-tab.js?babel-target=es6 + 1 modules
i("XgHN"),i("XZNo"),i("h/KH"),i("70OO"),i("fBRI"),i("y+0W"),i("7L45");
// EXTERNAL MODULE: ./node_modules/@vaadin/vaadin-lumo-styles/font-icons.js?babel-target=es6
var r=i("o5Wi");
// CONCATENATED MODULE: ./node_modules/@vaadin/vaadin-tabs/theme/lumo/vaadin-tabs-styles.js?babel-target=es6
const a=r.a`<dom-module id="lumo-tabs" theme-for="vaadin-tabs"><template><style>:host{-webkit-tap-highlight-color:transparent}:host(:not([orientation=vertical])){box-shadow:inset 0 -1px 0 0 var(--lumo-contrast-10pct);position:relative;min-height:var(--lumo-size-l)}:host([orientation=horizontal]) [part=tabs] ::slotted(vaadin-tab:not([theme~=icon-on-top])){justify-content:center}:host([orientation=vertical]){box-shadow:-1px 0 0 0 var(--lumo-contrast-10pct)}:host([orientation=horizontal]) [part=tabs]{margin:0 .75rem}:host([orientation=vertical]) [part=tabs]{width:100%;margin:.5rem 0}[part=back-button],[part=forward-button]{position:absolute;z-index:1;font-family:lumo-icons;color:var(--lumo-tertiary-text-color);font-size:var(--lumo-icon-size-m);display:flex;align-items:center;justify-content:center;width:1.5em;height:100%;transition:.2s opacity;top:0}[part=back-button]:hover,[part=forward-button]:hover{color:inherit}:host(:not([dir=rtl])) [part=forward-button]{right:0}[part=forward-button]::after{content:var(--lumo-icons-angle-right)}[part=back-button]::after{content:var(--lumo-icons-angle-left)}[part=tabs]{--_lumo-tabs-overflow-mask-image:none;-webkit-mask-image:var(--_lumo-tabs-overflow-mask-image);min-height:var(--lumo-size-l)}@-moz-document url-prefix(){[part=tabs]{mask-image:var(--_lumo-tabs-overflow-mask-image)}}:host([overflow~=start][overflow~=end]:not([orientation=vertical])) [part=tabs]{--_lumo-tabs-overflow-mask-image:linear-gradient(90deg, transparent 2em, #000 4em, #000 calc(100% - 4em), transparent calc(100% - 2em))}:host([overflow~=end]:not([orientation=vertical])) [part=tabs]{--_lumo-tabs-overflow-mask-image:linear-gradient(90deg, #000 calc(100% - 4em), transparent calc(100% - 2em))}:host([overflow~=start]:not([orientation=vertical])) [part=tabs]{--_lumo-tabs-overflow-mask-image:linear-gradient(90deg, transparent 2em, #000 4em)}:host([overflow~=start][overflow~=end][orientation=vertical]) [part=tabs]{--_lumo-tabs-overflow-mask-image:linear-gradient(transparent, #000 2em, #000 calc(100% - 2em), transparent)}:host([overflow~=end][orientation=vertical]) [part=tabs]{--_lumo-tabs-overflow-mask-image:linear-gradient(#000 calc(100% - 2em), transparent)}:host([overflow~=start][orientation=vertical]) [part=tabs]{--_lumo-tabs-overflow-mask-image:linear-gradient(transparent, #000 2em)}:host [part=tabs] ::slotted(:not(vaadin-tab)){margin-left:var(--lumo-space-m)}:host([theme~=centered][orientation=horizontal]) [part=tabs]{justify-content:center}:host([theme~=small]),:host([theme~=small]) [part=tabs]{min-height:var(--lumo-size-m)}:host([theme~=small]) [part=tabs] ::slotted(vaadin-tab){font-size:var(--lumo-font-size-s)}:host([theme~=minimal]){box-shadow:none;--_lumo-tab-marker-display:none}:host([theme~=minimal]) [part=tabs] ::slotted(vaadin-tab[selected])::after,:host([theme~=minimal]) [part=tabs] ::slotted(vaadin-tab[selected])::before{display:none}:host([theme~=hide-scroll-buttons]) [part=back-button],:host([theme~=hide-scroll-buttons]) [part=forward-button]{display:none}:host([theme~=hide-scroll-buttons][overflow~=start][overflow~=end]:not([orientation=vertical])) [part=tabs]{--_lumo-tabs-overflow-mask-image:linear-gradient(90deg, transparent, #000 2em, #000 calc(100% - 2em), transparent 100%)}:host([theme~=hide-scroll-buttons][overflow~=end]:not([orientation=vertical])) [part=tabs]{--_lumo-tabs-overflow-mask-image:linear-gradient(90deg, #000 calc(100% - 2em), transparent 100%)}:host([theme~=hide-scroll-buttons][overflow~=start]:not([orientation=vertical])) [part=tabs]{--_lumo-tabs-overflow-mask-image:linear-gradient(90deg, transparent, #000 2em)}:host([theme~=equal-width-tabs]){flex:auto}:host([theme~=equal-width-tabs]) [part=tabs] ::slotted(vaadin-tab){flex:1 0 0%}:host([dir=rtl]) [part=forward-button]::after{content:var(--lumo-icons-angle-left)}:host([dir=rtl]) [part=back-button]::after{content:var(--lumo-icons-angle-right)}:host([orientation=vertical][dir=rtl]){box-shadow:1px 0 0 0 var(--lumo-contrast-10pct)}:host([dir=rtl]) [part=forward-button]{left:0}:host([dir=rtl]) [part=tabs] ::slotted(:not(vaadin-tab)){margin-left:0;margin-right:var(--lumo-space-m)}:host([dir=rtl][overflow~=start][overflow~=end]:not([orientation=vertical])) [part=tabs]{--_lumo-tabs-overflow-mask-image:linear-gradient(-90deg, transparent 2em, #000 4em, #000 calc(100% - 4em), transparent calc(100% - 2em))}:host([dir=rtl][overflow~=end]:not([orientation=vertical])) [part=tabs]{--_lumo-tabs-overflow-mask-image:linear-gradient(-90deg, #000 calc(100% - 4em), transparent calc(100% - 2em))}:host([dir=rtl][overflow~=start]:not([orientation=vertical])) [part=tabs]{--_lumo-tabs-overflow-mask-image:linear-gradient(-90deg, transparent 2em, #000 4em)}:host([dir=rtl][theme~=hide-scroll-buttons][overflow~=start][overflow~=end]:not([orientation=vertical])) [part=tabs]{--_lumo-tabs-overflow-mask-image:linear-gradient(-90deg, transparent, #000 2em, #000 calc(100% - 2em), transparent 100%)}:host([dir=rtl][theme~=hide-scroll-buttons][overflow~=end]:not([orientation=vertical])) [part=tabs]{--_lumo-tabs-overflow-mask-image:linear-gradient(-90deg, #000 calc(100% - 2em), transparent 100%)}:host([dir=rtl][theme~=hide-scroll-buttons][overflow~=start]:not([orientation=vertical])) [part=tabs]{--_lumo-tabs-overflow-mask-image:linear-gradient(-90deg, transparent, #000 2em)}</style></template></dom-module>`;document.head.appendChild(a.content);
// EXTERNAL MODULE: ./node_modules/@polymer/polymer/polymer-element.js?babel-target=es6
var o=i("F3iu"),n=i("8u2h"),s=i("gmth"),l=i("JxY1"),d=i("OVu0"),A=(i("+qjT"),i("7BTU")),h=i("x3pe");
// EXTERNAL MODULE: ./node_modules/@vaadin/vaadin-themable-mixin/vaadin-themable-mixin.js?babel-target=es6
// CONCATENATED MODULE: ./node_modules/@vaadin/vaadin-tabs/src/vaadin-tabs.js?babel-target=es6
/**
@license
Copyright (c) 2017 Vaadin Ltd.
This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
*/
const u=/Apple.* Version\/(9|10)/.test(navigator.userAgent);
/**
 * `<vaadin-tabs>` is a Web Component for easy switching between different views.
 *
 * ```
 *   <vaadin-tabs selected="4">
 *     <vaadin-tab>Page 1</vaadin-tab>
 *     <vaadin-tab>Page 2</vaadin-tab>
 *     <vaadin-tab>Page 3</vaadin-tab>
 *     <vaadin-tab>Page 4</vaadin-tab>
 *   </vaadin-tabs>
 * ```
 *
 * ### Styling
 *
 * The following shadow DOM parts are available for styling:
 *
 * Part name         | Description
 * ------------------|--------------------------------------
 * `back-button`     | Button for moving the scroll back
 * `tabs`            | The tabs container
 * `forward-button`  | Button for moving the scroll forward
 *
 * The following state attributes are available for styling:
 *
 * Attribute  | Description | Part name
 * -----------|-------------|------------
 * `orientation` | Tabs disposition, valid values are `horizontal` and `vertical`. | :host
 * `overflow` | It's set to `start`, `end`, none or both. | :host
 *
 * See [ThemableMixin – how to apply styles for shadow parts](https://github.com/vaadin/vaadin-themable-mixin/wiki)
 *
 * @extends PolymerElement
 * @mixes ElementMixin
 * @mixes ListMixin
 * @mixes ThemableMixin
 * @demo demo/index.html
 */class p extends(Object(d.a)(Object(s.a)(Object(n.a)(Object(h.b)([l.a],o.a))))){static get template(){return r.a`<style>:host{display:flex;align-items:center}:host([hidden]){display:none!important}:host([orientation=vertical]){display:block}:host([orientation=horizontal]) [part=tabs]{flex-grow:1;display:flex;align-self:stretch;overflow-x:auto;-webkit-overflow-scrolling:touch;-ms-overflow-style:none}@-moz-document url-prefix(){:host([orientation=horizontal]) [part=tabs]{overflow:hidden}}:host([orientation=horizontal]) [part=tabs]::-webkit-scrollbar{display:none}:host([orientation=vertical]) [part=tabs]{height:100%;overflow-y:auto;-webkit-overflow-scrolling:touch}[part=back-button],[part=forward-button]{pointer-events:none;opacity:0;cursor:default}:host([overflow~=end]) [part=forward-button],:host([overflow~=start]) [part=back-button]{pointer-events:auto;opacity:1}[part=back-button]::after{content:'◀'}[part=forward-button]::after{content:'▶'}:host([orientation=vertical]) [part=back-button],:host([orientation=vertical]) [part=forward-button]{display:none}:host([dir=rtl]) [part=back-button]::after{content:'▶'}:host([dir=rtl]) [part=forward-button]::after{content:'◀'}</style><div on-click="_scrollBack" part="back-button"></div><div id="scroll" part="tabs"><slot></slot></div><div on-click="_scrollForward" part="forward-button"></div>`}static get is(){return"vaadin-tabs"}static get version(){return"3.2.0"}static get properties(){return{
/**
       * Set tabs disposition. Possible values are `horizontal|vertical`
       * @type {!ListOrientation}
       */
orientation:{value:"horizontal",type:String},
/**
       * The index of the selected tab.
       */
selected:{value:0,type:Number}}}static get observers(){return["_updateOverflow(items.*, vertical)"]}ready(){super.ready(),this.addEventListener("iron-resize",()=>this._updateOverflow()),this._scrollerElement.addEventListener("scroll",()=>this._updateOverflow()),this.setAttribute("role","tablist"),// Wait for the vaadin-tab elements to upgrade and get styled
Object(A.a)(this,()=>{this._updateOverflow()})}
/** @private */_scrollForward(){this._scroll(-this.__direction*this._scrollOffset)}
/** @private */_scrollBack(){this._scroll(this.__direction*this._scrollOffset)}
/**
   * @return {number}
   * @protected
   */get _scrollOffset(){return this._vertical?this._scrollerElement.offsetHeight:this._scrollerElement.offsetWidth}
/**
   * @return {!HTMLElement}
   * @protected
   */get _scrollerElement(){return this.$.scroll}
/** @private */get __direction(){return this._vertical||"rtl"!==this.getAttribute("dir")?-1:1}
/** @private */_updateOverflow(){const t=this._vertical?this._scrollerElement.scrollTop:this.__getNormalizedScrollLeft(this._scrollerElement);let e=this._vertical?this._scrollerElement.scrollHeight:this._scrollerElement.scrollWidth;// In Edge we need to adjust the size in 1 pixel
e-=1;let i=t>0?"start":"";i+=t+this._scrollOffset<e?" end":"",1==this.__direction&&(i=i.replace(/start|end/gi,t=>"start"===t?"end":"start")),i?this.setAttribute("overflow",i.trim()):this.removeAttribute("overflow"),this._repaintShadowNodesHack()}
/** @private */_repaintShadowNodesHack(){
// Safari 10 has an issue with repainting shadow root element styles when a host attribute changes.
// Need this workaround (toggle any inline css property on and off) until the issue gets fixed.
/* istanbul ignore if */
if(u&&this.root){const t="-webkit-backface-visibility";this.root.querySelectorAll("*").forEach(e=>{e.style[t]="visible",e.style[t]=""})}}}customElements.define(p.is,p)},
/***/wZOt:
/***/function(t,e,i){"use strict";
/* harmony export (binding) */i.d(e,"a",(function(){return l}));
/* harmony import */var r=i("Y40L"),a=i("9nmN");
/* harmony import */
/**
@license
Copyright (c) 2017 Vaadin Ltd.
This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
*/
const o=i("o5Wi").a`<dom-module id="vaadin-text-field-shared-styles"><template><style>:host{display:inline-flex;outline:0}:host::before{content:"\\2003";width:0;display:inline-block}:host([hidden]){display:none!important}.vaadin-text-area-container,.vaadin-text-field-container{display:flex;flex-direction:column;min-width:100%;max-width:100%;width:var(--vaadin-text-field-default-width,12em)}[part=label]:empty{display:none}[part=input-field]{display:flex;align-items:center;flex:auto}.vaadin-text-field-container [part=input-field]{flex-grow:0}[part=input-field] ::slotted(input),[part=input-field] ::slotted(textarea),[part=value]{-webkit-appearance:none;-moz-appearance:none;outline:0;margin:0;padding:0;border:0;border-radius:0;min-width:0;font:inherit;font-size:1em;line-height:normal;color:inherit;background-color:transparent;box-shadow:none}[part=input-field] ::slotted(*){flex:none}[part=input-field] ::slotted([part=value]),[part=input-field] ::slotted(input),[part=input-field] ::slotted(textarea),[part=value]{flex:auto;white-space:nowrap;overflow:hidden;width:100%;height:100%}[part=input-field] ::slotted(textarea){resize:none}[part=input-field] ::slotted(input)::-ms-clear,[part=value]::-ms-clear{display:none}[part=clear-button]{cursor:default}[part=clear-button]::before{content:"✕"}</style></template></dom-module>`;document.head.appendChild(o.content);const n={default:["list","autofocus","pattern","autocapitalize","autocorrect","maxlength","minlength","name","placeholder","autocomplete","title","disabled","readonly","required"],accessible:["invalid"]},s={DEFAULT:"default",ACCESSIBLE:"accessible"},l=t=>class extends t{static get properties(){return{
/**
       * Whether the value of the control can be automatically completed by the browser.
       * List of available options at:
       * https://developer.mozilla.org/en/docs/Web/HTML/Element/input#attr-autocomplete
       */
autocomplete:{type:String},
/**
       * This is a property supported by Safari that is used to control whether
       * autocorrection should be enabled when the user is entering/editing the text.
       * Possible values are:
       * on: Enable autocorrection.
       * off: Disable autocorrection.
       * @type {!TextFieldAutoCorrect | undefined}
       */
autocorrect:{type:String},
/**
       * This is a property supported by Safari and Chrome that is used to control whether
       * autocapitalization should be enabled when the user is entering/editing the text.
       * Possible values are:
       * characters: Characters capitalization.
       * words: Words capitalization.
       * sentences: Sentences capitalization.
       * none: No capitalization.
       * @type {!TextFieldAutoCapitalize | undefined}
       */
autocapitalize:{type:String},
/**
       * Specify that the value should be automatically selected when the field gains focus.
       * @type {boolean}
       */
autoselect:{type:Boolean,value:!1},
/**
       * Set to true to display the clear icon which clears the input.
       * @attr {boolean} clear-button-visible
       * @type {boolean}
       */
clearButtonVisible:{type:Boolean,value:!1},
/**
       * Error to show when the input value is invalid.
       * @attr {string} error-message
       * @type {string}
       */
errorMessage:{type:String,value:"",observer:"_errorMessageChanged"},
/**
       * Object with translated strings used for localization. Has
       * the following structure and default values:
       *
       * ```
       * {
       *   // Translation of the clear icon button accessible label
       *   clear: 'Clear'
       * }
       * ```
       * @type {{clear: string}}
       */
i18n:{type:Object,value:()=>({clear:"Clear"})},
/**
       * String used for the label element.
       * @type {string}
       */
label:{type:String,value:"",observer:"_labelChanged"},
/**
       * String used for the helper text.
       * @attr {string} helper-text
       * @type {string | null}
       */
helperText:{type:String,value:"",observer:"_helperTextChanged"},
/**
       * Maximum number of characters (in Unicode code points) that the user can enter.
       */
maxlength:{type:Number},
/**
       * Minimum number of characters (in Unicode code points) that the user can enter.
       */
minlength:{type:Number},
/**
       * The name of the control, which is submitted with the form data.
       */
name:{type:String},
/**
       * A hint to the user of what can be entered in the control.
       */
placeholder:{type:String},
/**
       * This attribute indicates that the user cannot modify the value of the control.
       */
readonly:{type:Boolean,reflectToAttribute:!0},
/**
       * Specifies that the user must fill in a value.
       */
required:{type:Boolean,reflectToAttribute:!0},
/**
       * The initial value of the control.
       * It can be used for two-way data binding.
       * @type {string}
       */
value:{type:String,value:"",observer:"_valueChanged",notify:!0},
/**
       * This property is set to true when the control value is invalid.
       * @type {boolean}
       */
invalid:{type:Boolean,reflectToAttribute:!0,notify:!0,value:!1},
/**
       * Specifies that the text field has value.
       * @attr {boolean} has-value
       */
hasValue:{type:Boolean,reflectToAttribute:!0},
/**
       * When set to true, user is prevented from typing a value that
       * conflicts with the given `pattern`.
       * @attr {boolean} prevent-invalid-input
       */
preventInvalidInput:{type:Boolean},
/**
       * A pattern matched against individual characters the user inputs.
       * When set, the field will prevent:
       * - `keyDown` events if the entered key doesn't match `/^_enabledCharPattern$/`
       * - `paste` events if the pasted text doesn't match `/^_enabledCharPattern*$/`
       * - `drop` events if the dropped text doesn't match `/^_enabledCharPattern*$/`
       *
       * For example, to enable entering only numbers and minus signs,
       * `_enabledCharPattern = "[\\d-]"`
       * @protected
       */
_enabledCharPattern:String,
/** @private */
_labelId:String,
/** @private */
_helperTextId:String,
/** @private */
_errorId:String,
/** @private */
_inputId:String,
/** @private */
_hasSlottedHelper:Boolean}}static get observers(){return["_stateChanged(disabled, readonly, clearButtonVisible, hasValue)","_hostPropsChanged("+n.default.join(", ")+")","_hostAccessiblePropsChanged("+n.accessible.join(", ")+")","_getActiveErrorId(invalid, errorMessage, _errorId, helperText, _helperTextId, _hasSlottedHelper)","_getActiveLabelId(label, _labelId, _inputId)","__observeOffsetHeight(errorMessage, invalid, label, helperText)","__enabledCharPatternChanged(_enabledCharPattern)"]}
/**
   * @return {HTMLElement | undefined}
   * @protected
   */get focusElement(){if(!this.shadowRoot)return;const t=this.querySelector(`${this._slottedTagName}[slot="${this._slottedTagName}"]`);return t||this.shadowRoot.querySelector('[part="value"]')}
/**
   * @return {HTMLElement | undefined}}
   * @protected
   */get inputElement(){return this.focusElement}
/**
   * @return {string}
   * @protected
   */get _slottedTagName(){return"input"}
/** @protected */_createConstraintsObserver(){
// This complex observer needs to be added dynamically here (instead of defining it above in the `get observers()`)
// so that it runs after complex observers of inheriting classes. Otherwise e.g. `_stepOrMinChanged()` observer of
// vaadin-number-field would run after this and the `min` and `step` properties would not yet be propagated to
// the `inputElement` when this runs.
this._createMethodObserver("_constraintsChanged(required, minlength, maxlength, pattern)")}
/** @private */_onInput(t){if(this.__preventInput)return t.stopImmediatePropagation(),void(this.__preventInput=!1);if(this.preventInvalidInput){const t=this.inputElement;if(t.value.length>0&&!this.checkValidity())return t.value=this.value||"",// add input-prevented attribute for 200ms
this.setAttribute("input-prevented",""),void(this._inputDebouncer=a.a.debounce(this._inputDebouncer,r.d.after(200),()=>{this.removeAttribute("input-prevented")}))}t.__fromClearButton||(this.__userInput=!0),this.value=t.target.value,this.__userInput=!1}// NOTE(yuriy): Workaround needed for IE11 and Edge for proper displaying
// of the clear button instead of setting display property for it depending on state.
/** @private */
_stateChanged(t,e,i,r){!t&&!e&&i&&r?this.$.clearButton.removeAttribute("hidden"):this.$.clearButton.setAttribute("hidden",!0)}
/**
   * @param {!Event} e
   * @protected
   */_onChange(t){if(this._valueClearing)return;// In the Shadow DOM, the `change` event is not leaked into the
// ancestor tree, so we must do this manually.
const e=new CustomEvent("change",{detail:{sourceEvent:t},bubbles:t.bubbles,cancelable:t.cancelable});this.dispatchEvent(e)}
/**
   * @param {unknown} newVal
   * @param {unknown} oldVal
   * @protected
   */_valueChanged(t,e){
// setting initial value to empty string, skip validation
""===t&&void 0===e||(this.hasValue=""!==t&&null!=t,this.__userInput||(void 0!==t?this.inputElement.value=t:this.value=this.inputElement.value="",this.invalid&&this.validate()))}
/** @private */_labelChanged(t){this._setOrToggleAttribute("has-label",!!t,this)}
/** @private */_helperTextChanged(t){this._setOrToggleAttribute("has-helper",!!t,this)}
/** @private */_errorMessageChanged(t){this._setOrToggleAttribute("has-error-message",!!t,this)}
/** @private */_onHelperSlotChange(){const t=this.shadowRoot.querySelector('[name="helper"]').assignedNodes({flatten:!0});// Only has slotted helper if not a text node
// Text nodes are added by the helperText prop and not the helper slot
// The filter is added due to shady DOM triggering this callback on helperText prop change
this._hasSlottedHelper=t.filter(t=>3!==t.nodeType).length,this._hasSlottedHelper?this.setAttribute("has-helper","slotted"):""!==this.helperText&&null!==this.helperText||this.removeAttribute("has-helper")}
/** @private */_onSlotChange(){const t=this.querySelector(`${this._slottedTagName}[slot="${this._slottedTagName}"]`);this.value&&(this.inputElement.value=this.value,this.validate()),t&&!this._slottedInput?(this._validateSlottedValue(t),this._addInputListeners(t),this._addIEListeners(t),this._slottedInput=t):!t&&this._slottedInput&&(this._removeInputListeners(this._slottedInput),this._removeIEListeners(this._slottedInput),this._slottedInput=void 0),Object.keys(s).map(t=>s[t]).forEach(t=>this._propagateHostAttributes(n[t].map(t=>this[t]),t))}
/** @private */_hostPropsChanged(...t){this._propagateHostAttributes(t,s.DEFAULT)}
/** @private */_hostAccessiblePropsChanged(...t){this._propagateHostAttributes(t,s.ACCESSIBLE)}
/** @private */_validateSlottedValue(t){t.value!==this.value&&(console.warn("Please define value on the vaadin-text-field component!"),t.value="")}
/** @private */_propagateHostAttributes(t,e){const i=this.inputElement,r=n[e];e===s.ACCESSIBLE?r.forEach((e,r)=>{this._setOrToggleAttribute(e,t[r],i),this._setOrToggleAttribute("aria-"+e,!!t[r]&&"true",i)}):r.forEach((e,r)=>{this._setOrToggleAttribute(e,t[r],i)})}
/** @private */_setOrToggleAttribute(t,e,i){t&&i&&(e?i.setAttribute(t,"boolean"==typeof e?"":e):i.removeAttribute(t))}
/**
   * @param {boolean | undefined} required
   * @param {number | undefined} minlength
   * @param {number | undefined} maxlength
   * @param {string | undefined} maxlength
   * @protected
   */_constraintsChanged(t,e,i,r){this.invalid&&(t||e||i||r?this.validate():this.invalid=!1)}
/**
   * Returns true if the current input value satisfies all constraints (if any)
   * @return {boolean}
   */checkValidity(){
// Note (Yuriy): `__forceCheckValidity` is used in containing components (i.e. `vaadin-date-picker`) in order
// to force the checkValidity instead of returning the previous invalid state.
return this.required||this.pattern||this.maxlength||this.minlength||this.__forceCheckValidity?this.inputElement.checkValidity():!this.invalid}
/** @private */_addInputListeners(t){t.addEventListener("input",this._boundOnInput),t.addEventListener("change",this._boundOnChange),t.addEventListener("blur",this._boundOnBlur),t.addEventListener("focus",this._boundOnFocus),t.addEventListener("paste",this._boundOnPaste),t.addEventListener("drop",this._boundOnDrop),t.addEventListener("beforeinput",this._boundOnBeforeInput)}
/** @private */_removeInputListeners(t){t.removeEventListener("input",this._boundOnInput),t.removeEventListener("change",this._boundOnChange),t.removeEventListener("blur",this._boundOnBlur),t.removeEventListener("focus",this._boundOnFocus),t.removeEventListener("paste",this._boundOnPaste),t.removeEventListener("drop",this._boundOnDrop),t.removeEventListener("beforeinput",this._boundOnBeforeInput)}
/** @protected */ready(){super.ready(),this._createConstraintsObserver(),this._boundOnInput=this._onInput.bind(this),this._boundOnChange=this._onChange.bind(this),this._boundOnBlur=this._onBlur.bind(this),this._boundOnFocus=this._onFocus.bind(this),this._boundOnPaste=this._onPaste.bind(this),this._boundOnDrop=this._onDrop.bind(this),this._boundOnBeforeInput=this._onBeforeInput.bind(this);const t=this.shadowRoot.querySelector('[part="value"]');this._slottedInput=this.querySelector(`${this._slottedTagName}[slot="${this._slottedTagName}"]`),this._addInputListeners(t),this._addIEListeners(t),this._slottedInput&&(this._addIEListeners(this._slottedInput),this._addInputListeners(this._slottedInput)),this.shadowRoot.querySelector('[name="input"], [name="textarea"]').addEventListener("slotchange",this._onSlotChange.bind(this)),this._onHelperSlotChange(),this.shadowRoot.querySelector('[name="helper"]').addEventListener("slotchange",this._onHelperSlotChange.bind(this)),window.ShadyCSS&&window.ShadyCSS.nativeCss||this.updateStyles(),this.$.clearButton.addEventListener("mousedown",()=>this._valueClearing=!0),this.$.clearButton.addEventListener("mouseleave",()=>this._valueClearing=!1),this.$.clearButton.addEventListener("click",this._onClearButtonClick.bind(this)),this.addEventListener("keydown",this._onKeyDown.bind(this));var e=l._uniqueId=1+l._uniqueId||0;this._errorId=`${this.constructor.is}-error-${e}`,this._labelId=`${this.constructor.is}-label-${e}`,this._helperTextId=`${this.constructor.is}-helper-${e}`,this._inputId=`${this.constructor.is}-input-${e}`,// Lumo theme defines a max-height transition for the "error-message"
// part on invalid state change.
this.shadowRoot.querySelector('[part="error-message"]').addEventListener("transitionend",()=>{this.__observeOffsetHeight()})}
/**
   * Returns true if `value` is valid.
   * `<iron-form>` uses this to check the validity for all its elements.
   *
   * @return {boolean} True if the value is valid.
   */validate(){return!(this.invalid=!this.checkValidity())}clear(){this.value=""}
/** @private */_onBlur(){this.validate()}
/** @private */_onFocus(){this.autoselect&&(this.inputElement.select(),// iOS 9 workaround: https://stackoverflow.com/a/7436574
setTimeout(()=>{try{this.inputElement.setSelectionRange(0,9999)}catch(t){// The workaround may cause errors on different input types.
// Needs to be suppressed. See https://github.com/vaadin/flow/issues/6070
}}))}
/** @private */_onClearButtonClick(t){t.preventDefault(),// NOTE(yuriy): This line won't affect focus on the host. Cannot be properly tested.
this.inputElement.focus(),this.clear(),this._valueClearing=!1,navigator.userAgent.match(/Trident/)&&(
// Disable IE input" event prevention here, we want the input event from
// below to propagate normally.
this.__preventInput=!1);const e=new Event("input",{bubbles:!0,composed:!0});e.__fromClearButton=!0;const i=new Event("change",{bubbles:!this._slottedInput});i.__fromClearButton=!0,this.inputElement.dispatchEvent(e),this.inputElement.dispatchEvent(i)}
/**
   * @param {!KeyboardEvent} e
   * @protected
   */_onKeyDown(t){if(27===t.keyCode&&this.clearButtonVisible){const t=!!this.value;this.clear(),t&&this.inputElement.dispatchEvent(new Event("change",{bubbles:!this._slottedInput}))}this._enabledCharPattern&&!this.__shouldAcceptKey(t)&&t.preventDefault()}
/** @private */__shouldAcceptKey(t){return t.metaKey||t.ctrlKey||!t.key||1!==t.key.length||this.__enabledCharRegExp.test(t.key)}
/** @private */_onPaste(t){if(this._enabledCharPattern){const e=(t.clipboardData||window.clipboardData).getData("text");this.__enabledTextRegExp.test(e)||t.preventDefault()}}
/** @private */_onDrop(t){if(this._enabledCharPattern){const e=t.dataTransfer.getData("text");this.__enabledTextRegExp.test(e)||t.preventDefault()}}
/** @private */_onBeforeInput(t){
// The `beforeinput` event covers all the cases for `_enabledCharPattern`: keyboard, pasting and dropping,
// but it is still experimental technology so we can't rely on it. It's used here just as an additional check,
// because it seems to be the only way to detect and prevent specific keys on mobile devices. See issue #429.
this._enabledCharPattern&&t.data&&!this.__enabledTextRegExp.test(t.data)&&t.preventDefault()}
/** @private */__enabledCharPatternChanged(t){this.__enabledCharRegExp=t&&new RegExp("^"+t+"$"),this.__enabledTextRegExp=t&&new RegExp("^"+t+"*$")}
/** @private */_addIEListeners(t){
/* istanbul ignore if */
navigator.userAgent.match(/Trident/)&&(
// IE11 dispatches `input` event in following cases:
// - focus or blur, when placeholder attribute is set
// - placeholder attribute value changed
// https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/101220/
this._shouldPreventInput=()=>{this.__preventInput=!0,requestAnimationFrame(()=>{this.__preventInput=!1})},t.addEventListener("focusin",this._shouldPreventInput),t.addEventListener("focusout",this._shouldPreventInput),this._createPropertyObserver("placeholder",this._shouldPreventInput))}
/** @private */_removeIEListeners(t){
/* istanbul ignore if */
navigator.userAgent.match(/Trident/)&&(t.removeEventListener("focusin",this._shouldPreventInput),t.removeEventListener("focusout",this._shouldPreventInput))}
/** @private */_getActiveErrorId(t,e,i,r,a,o){const n=[];(r||o)&&n.push(a),e&&t&&n.push(i),this._setOrToggleAttribute("aria-describedby",n.join(" "),this.focusElement)}
/** @private */_getActiveLabelId(t,e,i){let r=i;t&&(r=`${e} ${i}`),this.focusElement.setAttribute("aria-labelledby",r)}
/** @private */_getErrorMessageAriaHidden(t,e,i){return(!(e&&t?i:void 0)).toString()}
/** @private */_dispatchIronResizeEventIfNeeded(t,e){const i="__previous"+t;void 0!==this[i]&&this[i]!==e&&this.dispatchEvent(new CustomEvent("iron-resize",{bubbles:!0,composed:!0})),this[i]=e}
/** @private */__observeOffsetHeight(){this.__observeOffsetHeightDebouncer=a.a.debounce(this.__observeOffsetHeightDebouncer,r.a,()=>{this._dispatchIronResizeEventIfNeeded("Height",this.offsetHeight)})}
/**
   * @param {string} prop
   * @param {string} oldVal
   * @param {string} newVal
   * @protected
   */attributeChangedCallback(t,e,i){super.attributeChangedCallback(t,e,i),// Needed until Edge has CSS Custom Properties (present in Edge Preview)
/* istanbul ignore if */
window.ShadyCSS&&window.ShadyCSS.nativeCss||!/^(focused|focus-ring|invalid|disabled|placeholder|has-value)$/.test(t)||this.updateStyles();
/* istanbul ignore if */
if(/^((?!chrome|android).)*safari/i.test(navigator.userAgent)&&this.root){const t="-webkit-backface-visibility";this.root.querySelectorAll("*").forEach(e=>{e.style[t]="visible",e.style[t]=""})}}// Workaround for https://github.com/Polymer/polymer/issues/5259
get __data(){return this.__dataValue||{}}set __data(t){this.__dataValue=t}
/**
   * Fired when the user commits a value change.
   *
   * @event change
   */
/**
   * Fired when the value is changed by the user: on every typing keystroke,
   * and the value is cleared using the clear button.
   *
   * @event input
   */
/**
   * Fired when the size of the element changes.
   *
   * @event iron-resize
   */}
/***/}}]);